/**
 * CSTM Header Drawer JavaScript
 * Custom Header with Enterprise Search Engine v3.0
 * 
 * Features:
 * - Phonetic Search (Kölner Phonetik)
 * - N-Gram Matching for partial words
 * - Dynamic Shop Dictionary
 * - Intent Detection (price, size, new)
 * - German Stemming
 * - Enhanced SKU matching
 * - Smart "Did you mean?" suggestions
 * 
 * Extracted from cstm-header-drawer-menu.liquid for Shopify's 256KB file limit
 * All Liquid variables are passed via data-attributes on the header element
 */

(function() {
  function initCstmHeader(sectionId) {
    const header = document.getElementById(sectionId);
    if (!header || header.dataset.initialized === 'true') return;
    header.dataset.initialized = 'true';
    
    // Read config from data-attributes (set in Liquid)
    const config = header.dataset.config ? JSON.parse(header.dataset.config) : {};
    const SECTION_ID = sectionId;
    
    // ========================================
    // DRAWER FUNCTIONALITY
    // ========================================
    if (!header.querySelector('biwo-menu-drawer')) {
    const drawer = header.querySelector('[data-drawer]');
    const overlay = header.querySelector('[data-drawer-overlay]');
    const closeBtn = header.querySelector('[data-drawer-close]');
    const mobileToggle = header.querySelector('[data-mobile-toggle]');
    const navTriggers = header.querySelectorAll('[data-drawer-trigger]');
    const tabs = header.querySelectorAll('[data-drawer-tab]');
    const panelGroups = header.querySelectorAll('[data-panel-group]');
    
    let isOpen = false;
    let activeGroup = null;
    
    function openDrawer(groupHandle) {
      isOpen = true;
      header.classList.add('cdh--drawer-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      setActiveGroup(groupHandle);
      navTriggers.forEach(trigger => {
        trigger.setAttribute('aria-expanded', trigger.dataset.drawerTrigger === groupHandle ? 'true' : 'false');
      });
    }
    
    function closeDrawer() {
      isOpen = false;
      header.classList.remove('cdh--drawer-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      navTriggers.forEach(trigger => {
        trigger.setAttribute('aria-expanded', 'false');
      });
      setTimeout(() => { resetPanels(); }, 300);
    }
    
    function setActiveGroup(handle) {
      activeGroup = handle;
      panelGroups.forEach(group => {
        group.setAttribute('aria-hidden', group.dataset.panelGroup !== handle);
      });
      tabs.forEach(tab => {
        tab.setAttribute('aria-selected', tab.dataset.drawerTab === handle);
      });
      const activeGroupEl = header.querySelector(`[data-panel-group="${handle}"]`);
      if (activeGroupEl) resetPanelsInGroup(activeGroupEl);
      hideFeaturedOnDeepNavigation(1);
    }
    
    function resetPanels() {
      panelGroups.forEach(group => { resetPanelsInGroup(group); });
      hideFeaturedOnDeepNavigation(1);
    }
    
    function resetPanelsInGroup(group) {
      const panel2 = group.querySelector('[data-panel="2"]');
      const panel3 = group.querySelector('[data-panel="3"]');
      if (panel2) panel2.setAttribute('aria-hidden', 'true');
      if (panel3) panel3.setAttribute('aria-hidden', 'true');
      group.querySelectorAll('[data-panel-content]').forEach(content => {
        content.setAttribute('aria-hidden', 'true');
      });
      group.querySelectorAll('[data-active]').forEach(el => {
        el.removeAttribute('data-active');
      });
    }
    
    // ========================================
    // PANEL NAVIGATION HELPERS
    // ========================================
    function hideFeaturedOnDeepNavigation(level) {
      const featured = header.querySelector('.cdh-drawer-featured');
      if (featured) {
        featured.style.display = level > 1 ? 'none' : '';
      }
    }
    
    function showPanel(group, panelNum, targetHandle, triggerEl) {
      const panel = group.querySelector(`[data-panel="${panelNum}"]`);
      const content = panel?.querySelector(`[data-panel-content="${targetHandle}"]`);
      if (!panel || !content) return;
      panel.setAttribute('aria-hidden', 'false');
      panel.querySelectorAll('[data-panel-content]').forEach(c => {
        c.setAttribute('aria-hidden', c.dataset.panelContent !== targetHandle);
      });
      const prevPanel = group.querySelector(`[data-panel="${panelNum - 1}"]`);
      if (prevPanel) {
        prevPanel.querySelectorAll('[data-active]').forEach(el => el.removeAttribute('data-active'));
        if (triggerEl) triggerEl.setAttribute('data-active', 'true');
      }
      hideFeaturedOnDeepNavigation(panelNum);
    }
    
    function goBack(group, toPanelNum, backTarget) {
      for (let i = 3; i > toPanelNum; i--) {
        const panel = group.querySelector(`[data-panel="${i}"]`);
        if (panel) panel.setAttribute('aria-hidden', 'true');
      }
      if (toPanelNum === 2 && backTarget) {
        const panel2 = group.querySelector('[data-panel="2"]');
        if (panel2) {
          panel2.querySelectorAll('[data-panel-content]').forEach(c => {
            c.setAttribute('aria-hidden', c.dataset.panelContent !== backTarget);
          });
        }
      }
      hideFeaturedOnDeepNavigation(toPanelNum);
    }
    
    // Event Listeners
    navTriggers.forEach(trigger => {
      trigger.addEventListener('click', () => {
        const handle = trigger.dataset.drawerTrigger;
        if (isOpen && activeGroup === handle) closeDrawer();
        else openDrawer(handle);
      });
    });
    
    if (mobileToggle) {
      mobileToggle.addEventListener('click', () => {
        if (isOpen) closeDrawer();
        else {
          const firstTrigger = header.querySelector('[data-drawer-trigger]');
          if (firstTrigger) openDrawer(firstTrigger.dataset.drawerTrigger);
        }
      });
    }
    
    tabs.forEach(tab => {
      tab.addEventListener('click', () => { setActiveGroup(tab.dataset.drawerTab); });
    });
    
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);
    
    header.querySelectorAll('[data-panel-trigger]').forEach(trigger => {
      trigger.addEventListener('click', () => {
        const group = trigger.closest('[data-panel-group]');
        const panelNum = parseInt(trigger.dataset.panelTrigger);
        const targetHandle = trigger.dataset.target;
        showPanel(group, panelNum, targetHandle, trigger);
      });
    });
    
    header.querySelectorAll('[data-panel-back]').forEach(btn => {
      btn.addEventListener('click', () => {
        const group = btn.closest('[data-panel-group]');
        const toPanelNum = parseInt(btn.dataset.panelBack);
        const backTarget = btn.dataset.backTarget;
        goBack(group, toPanelNum, backTarget);
      });
    });
    
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && isOpen) closeDrawer();
    });
    
    }

    // ========================================
    // ENTERPRISE SEARCH ENGINE v4.0
    // ========================================
    // Features: Phonetic, N-Gram, Stemming, Intent Detection
    // + BAUMARKT INTELLIGENCE: Measurements, Properties, Usage, Metafields
    // ========================================
    
    // ╔════════════════════════════════════════════════════════════════╗
    // ║  PHASE 4: BAUMARKT SYNONYM DICTIONARY                          ║
    // ╚════════════════════════════════════════════════════════════════╝
    
    const BAUMARKT_SYNONYMS = {
      // Licht-Eigenschaften
      lichtdurchlässigkeit: {
        'lichtundurchlässig': ['opak', 'blickdicht', 'undurchsichtig', 'dunkel', 'lichtdicht', 'nicht-transparent', 'sichtschutz'],
        'lichtdurchlässig': ['transparent', 'durchsichtig', 'klar', 'hell', 'transluzent', 'durchscheinend', 'lichtecht'],
        'milchig': ['satiniert', 'matt', 'gefrostet', 'opal', 'diffus', 'getrübt'],
        'getönt': ['gefärbt', 'farbig', 'coloriert', 'bronzefarben', 'grau-getönt', 'rauchglas']
      },
      
      // Oberflächen
      oberflaeche: {
        'glatt': ['poliert', 'glänzend', 'hochglanz', 'geschliffen', 'plan'],
        'rau': ['strukturiert', 'genoppt', 'gerippt', 'geriffelt', 'antirutsch', 'rutschfest'],
        'matt': ['seidenmatt', 'stumpf', 'mattiert', 'satiniert'],
        'gebürstet': ['geschliffen', 'geburstet', 'brushed']
      },
      
      // Verwendungszweck
      verwendung: {
        'außen': ['outdoor', 'außenbereich', 'wetterfest', 'witterungsbeständig', 'uv-beständig', 'frostfest', 'garten', 'terrasse', 'balkon', 'carport', 'vordach', 'überdachung', 'gewächshaus', 'wintergarten'],
        'innen': ['indoor', 'innenbereich', 'wohnraum', 'büro', 'küche', 'bad', 'badezimmer', 'dusche', 'trennwand'],
        'feuchtraum': ['bad', 'badezimmer', 'dusche', 'nassraum', 'sauna', 'pool', 'feuchtigkeitsbeständig'],
        'werkstatt': ['garage', 'keller', 'lager', 'industrie', 'gewerbe']
      },
      
      // Material-Eigenschaften
      eigenschaften: {
        'bruchsicher': ['schlagfest', 'splitterfrei', 'bruchfest', 'unzerbrechlich', 'robust', 'stoßfest', 'hagelsicher'],
        'biegsam': ['flexibel', 'biegbar', 'elastisch', 'formbar'],
        'steif': ['starr', 'formstabil', 'massiv', 'fest', 'stabil'],
        'leicht': ['leichtgewicht', 'gewichtsreduziert', 'federleicht'],
        'schwer': ['massiv', 'gewichtig', 'stabil'],
        'isolierend': ['wärmedämmend', 'schalldämmend', 'dämmend', 'isoliert', 'doppelstegig', 'hohlkammer'],
        'feuerfest': ['brandschutz', 'schwer-entflammbar', 'nicht-brennbar', 'feuerhemmend', 'b1', 'a2']
      },
      
      // Befestigung & Montage
      befestigung: {
        'schrauben': ['verschrauben', 'schraubbar', 'bohren'],
        'kleben': ['verklebt', 'klebbar', 'kleber', 'silikon', 'montageband'],
        'klemmen': ['klemmbar', 'einklemmen', 'klemmleiste', 'klemmschiene'],
        'stecken': ['steckbar', 'einstecken', 'clip', 'clipsen']
      },
      
      // Materialien
      materialien: {
        'kunststoff': ['plastik', 'pvc', 'acryl', 'plexiglas', 'pmma', 'polycarbonat', 'pc', 'makrolon', 'lexan', 'petg', 'abs', 'pe', 'pp', 'polystyrol', 'ps', 'hips', 'dibond', 'alu-verbund', 'forex', 'hartschaum', 'kapa', 'kapafix', 'hobbycolor'],
        'holz': ['holzplatte', 'sperrholz', 'multiplex', 'mdf', 'hdf', 'osb', 'spanplatte', 'tischlerplatte', 'leimholz', 'massivholz', 'birke', 'buche', 'eiche', 'kiefer', 'fichte'],
        'metall': ['aluminium', 'alu', 'edelstahl', 'stahl', 'verzinkt', 'blech', 'lochblech', 'streckmetall'],
        'glas': ['echtglas', 'esg', 'vsg', 'floatglas', 'sicherheitsglas']
      },
      
      // Produkt-Typen
      produkttypen: {
        'platte': ['platten', 'scheibe', 'scheiben', 'tafel', 'tafeln', 'panel', 'paneel', 'paneele', 'board', 'sheet'],
        'profil': ['profile', 'leiste', 'leisten', 'schiene', 'schienen', 'u-profil', 'l-profil', 'h-profil', 'kantenschutz'],
        'rohr': ['rohre', 'röhre', 'tube', 'rundrohr', 'vierkantrohr', 'rechteckrohr'],
        'stab': ['stäbe', 'rundstab', 'stange', 'stangen'],
        'folie': ['folien', 'film', 'bahn', 'bahnen', 'rolle', 'rollen']
      },
      
      // Farben (erweitert für Baumarkt)
      farben: {
        'transparent': ['klar', 'farblos', 'durchsichtig', 'glasklar'],
        'weiß': ['weiss', 'white', 'reinweiß', 'schneeweiß', 'naturweiß', 'cremeweiß', 'opalweiß'],
        'schwarz': ['black', 'anthrazit', 'tiefschwarz', 'mattschwarz', 'graphit'],
        'grau': ['grey', 'gray', 'silber', 'hellgrau', 'dunkelgrau', 'anthrazit', 'steingrau'],
        'braun': ['brown', 'bronze', 'kupfer', 'rost', 'holzfarben', 'nussbaum', 'eiche'],
        'grün': ['green', 'moosgrün', 'tannengrün', 'smaragd', 'olivgrün'],
        'blau': ['blue', 'himmelblau', 'marine', 'navy', 'kobalt', 'saphir']
      }
    };
    
    // Flache Synonym-Map für schnelles Lookup
    const SYNONYM_LOOKUP = new Map();
    (function buildSynonymLookup() {
      Object.values(BAUMARKT_SYNONYMS).forEach(category => {
        Object.entries(category).forEach(([mainTerm, synonyms]) => {
          SYNONYM_LOOKUP.set(mainTerm.toLowerCase(), { mainTerm, synonyms });
          synonyms.forEach(syn => {
            SYNONYM_LOOKUP.set(syn.toLowerCase(), { mainTerm, synonyms });
          });
        });
      });
    })();
    
    function findBaumarktSynonyms(word) {
      const w = word.toLowerCase();
      const entry = SYNONYM_LOOKUP.get(w);
      if (entry) {
        return [entry.mainTerm, ...entry.synonyms].filter(s => s !== w);
      }
      // Partial match
      const matches = [];
      SYNONYM_LOOKUP.forEach((value, key) => {
        if (key.includes(w) || w.includes(key)) {
          matches.push(value.mainTerm);
        }
      });
      return [...new Set(matches)].slice(0, 5);
    }
    
    // ╔════════════════════════════════════════════════════════════════╗
    // ║  PHASE 1: QUERY INTELLIGENCE (Baumarkt-Anfragen parsen)        ║
    // ╚════════════════════════════════════════════════════════════════╝
    
    const MEASUREMENT_UNITS = {
      length: {
        'mm': 1, 'millimeter': 1,
        'cm': 10, 'zentimeter': 10,
        'dm': 100, 'dezimeter': 100,
        'm': 1000, 'meter': 1000,
        'in': 25.4, 'inch': 25.4, 'zoll': 25.4, '"': 25.4
      },
      thickness: {
        'mm': 1, 'millimeter': 1,
        'cm': 10, 'zentimeter': 10
      },
      area: {
        'mm²': 1, 'mm2': 1,
        'cm²': 100, 'cm2': 100,
        'dm²': 10000, 'dm2': 10000,
        'm²': 1000000, 'm2': 1000000, 'qm': 1000000, 'quadratmeter': 1000000
      }
    };
    
    function parseBaumarktQuery(query) {
      const result = {
        original: query,
        cleanQuery: query,
        measurements: [],       // { type, value, unit, normalizedMM }
        dimensions: null,       // { length, width, thickness }
        properties: [],         // ['lichtundurchlässig', 'bruchsicher']
        materials: [],          // ['kunststoff', 'acryl']
        colors: [],             // ['transparent', 'weiß']
        usage: [],              // ['außen', 'carport']
        productType: null,      // 'platte', 'profil'
        keywords: [],           // remaining search terms
        expandedTerms: []       // synonym-expanded terms
      };
      
      let q = query.toLowerCase().trim();
      
      // ===== 1. DIMENSIONEN PARSEN =====
      // Muster: 6m x 2m, 600x400x3mm, 100 x 50 cm
      const dimPatterns = [
        // 600x400x3mm oder 600 x 400 x 3 mm
        /(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)\s*(mm|cm|m)?/gi,
        // 600x400mm (ohne Dicke)
        /(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)\s*(mm|cm|m)?/gi,
        // 6m Länge, 2m breit
        /(\d+(?:[.,]\d+)?)\s*(mm|cm|dm|m|meter|zentimeter|millimeter)\s*(lang|länge|breit|breite|tief|tiefe|hoch|höhe|dick|dicke|stärke|stark)?/gi
      ];
      
      // 3D Dimensionen (LxBxH)
      const dim3D = q.match(/(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)\s*(mm|cm|m)?/i);
      if (dim3D) {
        const unit = dim3D[4] || 'mm';
        const factor = MEASUREMENT_UNITS.length[unit] || 1;
        result.dimensions = {
          length: parseFloat(dim3D[1].replace(',', '.')) * factor,
          width: parseFloat(dim3D[2].replace(',', '.')) * factor,
          thickness: parseFloat(dim3D[3].replace(',', '.')) * factor
        };
        q = q.replace(dim3D[0], ' ').trim();
      }
      
      // 2D Dimensionen (LxB)
      if (!result.dimensions) {
        const dim2D = q.match(/(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)\s*(mm|cm|m)?/i);
        if (dim2D) {
          const unit = dim2D[3] || 'mm';
          const factor = MEASUREMENT_UNITS.length[unit] || 1;
          result.dimensions = {
            length: parseFloat(dim2D[1].replace(',', '.')) * factor,
            width: parseFloat(dim2D[2].replace(',', '.')) * factor,
            thickness: null
          };
          q = q.replace(dim2D[0], ' ').trim();
        }
      }
      
      // Einzelne Maße
      const singleMeasurements = q.matchAll(/(\d+(?:[.,]\d+)?)\s*(mm|cm|dm|m|meter|zentimeter|millimeter|zoll|inch|")\b/gi);
      for (const match of singleMeasurements) {
        const value = parseFloat(match[1].replace(',', '.'));
        const unit = match[2].toLowerCase();
        const factor = MEASUREMENT_UNITS.length[unit] || 1;
        result.measurements.push({
          original: match[0],
          value: value,
          unit: unit,
          normalizedMM: value * factor
        });
        q = q.replace(match[0], ' ').trim();
      }
      
      // Dicke/Stärke spezifisch
      const thicknessMatch = q.match(/(\d+(?:[.,]\d+)?)\s*(mm|cm)?\s*(dick|dicke|stärke|stark|st)\b/i);
      if (thicknessMatch) {
        const value = parseFloat(thicknessMatch[1].replace(',', '.'));
        const unit = thicknessMatch[2] || 'mm';
        const factor = MEASUREMENT_UNITS.thickness[unit] || 1;
        if (!result.dimensions) result.dimensions = {};
        result.dimensions.thickness = value * factor;
        q = q.replace(thicknessMatch[0], ' ').trim();
      }
      
      // ===== 2. EIGENSCHAFTEN ERKENNEN =====
      Object.entries(BAUMARKT_SYNONYMS).forEach(([category, terms]) => {
        Object.entries(terms).forEach(([mainTerm, synonyms]) => {
          const allTerms = [mainTerm, ...synonyms];
          allTerms.forEach(term => {
            const termLower = term.toLowerCase();
            if (q.includes(termLower)) {
              if (category === 'farben') {
                if (!result.colors.includes(mainTerm)) result.colors.push(mainTerm);
              } else if (category === 'materialien') {
                if (!result.materials.includes(mainTerm)) result.materials.push(mainTerm);
              } else if (category === 'verwendung') {
                if (!result.usage.includes(mainTerm)) result.usage.push(mainTerm);
              } else if (category === 'produkttypen') {
                result.productType = mainTerm;
              } else {
                if (!result.properties.includes(mainTerm)) result.properties.push(mainTerm);
              }
              result.expandedTerms.push(...allTerms.filter(t => t !== term));
              // Entferne gefundenen Term aus Query
              q = q.replace(new RegExp(termLower.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'gi'), ' ');
            }
          });
        });
      });
      
      // ===== 3. VERWENDUNGSZWECK ERKENNEN =====
      const usagePatterns = [
        { pattern: /\b(für|fuer|zum|zur|als|bei)\s+(\w+)/gi, group: 2 },
        { pattern: /\b(carport|terasse|terrasse|balkon|garten|gewächshaus|wintergarten|vordach|überdachung|ueberdachung)\b/gi, group: 0 },
        { pattern: /\b(dusche|bad|küche|kueche|werkstatt|garage|keller|büro|buero|wohnzimmer)\b/gi, group: 0 }
      ];
      
      usagePatterns.forEach(({ pattern, group }) => {
        const matches = q.matchAll(pattern);
        for (const match of matches) {
          const usage = match[group].toLowerCase();
          if (!result.usage.includes(usage) && usage.length > 2) {
            result.usage.push(usage);
            // Map to main category
            Object.entries(BAUMARKT_SYNONYMS.verwendung).forEach(([main, synonyms]) => {
              if (synonyms.includes(usage) && !result.usage.includes(main)) {
                result.usage.push(main);
              }
            });
          }
        }
      });
      
      // ===== 4. STOP-WORDS ENTFERNEN & KEYWORDS EXTRAHIEREN =====
      const stopWords = new Set([
        'der', 'die', 'das', 'den', 'dem', 'des', 'ein', 'eine', 'einer', 'einem', 'einen',
        'und', 'oder', 'aber', 'für', 'fuer', 'mit', 'bei', 'nach', 'zu', 'zur', 'zum', 'von', 'vom',
        'im', 'in', 'an', 'am', 'auf', 'aus', 'durch', 'über', 'ueber', 'unter', 'vor', 'hinter',
        'ich', 'suche', 'brauche', 'möchte', 'moechte', 'will', 'kaufen', 'bestellen', 'haben',
        'bitte', 'gerne', 'mal', 'noch', 'auch', 'sehr', 'gut', 'günstig', 'guenstig'
      ]);
      
      q = q.replace(/\s+/g, ' ').trim();
      const words = q.split(/\s+/).filter(w => w.length > 1 && !stopWords.has(w));
      result.keywords = words;
      result.cleanQuery = words.join(' ');
      
      // ===== 5. EXPANDIERTE BEGRIFFE =====
      result.keywords.forEach(keyword => {
        const synonyms = findBaumarktSynonyms(keyword);
        result.expandedTerms.push(...synonyms);
      });
      result.expandedTerms = [...new Set(result.expandedTerms)];
      
      return result;
    }
    
    // ╔════════════════════════════════════════════════════════════════╗
    // ║  PHASE 2: PRODUCT INDEX (Vollständige Produktdaten + Metafields)║
    // ╚════════════════════════════════════════════════════════════════╝
    
    const productIndex = {
      products: new Map(),
      lastUpdate: 0,
      isLoading: false,
      isInitialized: false,
      maxAge: 1000 * 60 * 30, // 30 Minuten Cache
      
      async init(forceRefresh = false) {
        if (this.isLoading) return;
        if (this.isInitialized && !forceRefresh && Date.now() - this.lastUpdate < this.maxAge) {
          return;
        }
        
        this.isLoading = true;
        
        try {
          // Versuche aus localStorage zu laden
          const cached = this.loadFromStorage();
          if (cached && !forceRefresh) {
            this.products = new Map(Object.entries(cached.products));
            this.lastUpdate = cached.lastUpdate;
            this.isInitialized = true;
            this.isLoading = false;
            
            // Hintergrund-Update wenn älter als 5 Minuten
            if (Date.now() - this.lastUpdate > 1000 * 60 * 5) {
              this.backgroundUpdate();
            }
            return;
          }
          
          // Lade alle Produkte
          await this.fetchAllProducts();
          this.saveToStorage();
          this.isInitialized = true;
        } catch (error) {
          console.error('[ProductIndex] Init error:', error);
        } finally {
          this.isLoading = false;
        }
      },
      
      async fetchAllProducts() {
        const products = [];
        let page = 1;
        let hasMore = true;
        
        while (hasMore && page <= 10) { // Max 2500 Produkte
          try {
            const response = await fetch(
              `${window.Shopify?.routes?.root || '/'}products.json?limit=250&page=${page}`
            );
            
            if (!response.ok) {
              // Fallback: Versuche über Collection
              if (page === 1) {
                await this.fetchViaCollection();
                return;
              }
              break;
            }
            
            const data = await response.json();
            if (data.products && data.products.length > 0) {
              products.push(...data.products);
              page++;
              hasMore = data.products.length === 250;
            } else {
              hasMore = false;
            }
          } catch (error) {
            console.error(`[ProductIndex] Fetch page ${page} error:`, error);
            break;
          }
        }
        
        // Index aufbauen
        products.forEach(product => {
          this.products.set(product.id, this.processProduct(product));
        });
        
        this.lastUpdate = Date.now();
        console.log(`[ProductIndex] Indexed ${this.products.size} products`);
      },
      
      async fetchViaCollection() {
        try {
          const response = await fetch(
            `${window.Shopify?.routes?.root || '/'}collections/all/products.json?limit=250`
          );
          const data = await response.json();
          
          if (data.products) {
            data.products.forEach(product => {
              this.products.set(product.id, this.processProduct(product));
            });
          }
          
          this.lastUpdate = Date.now();
        } catch (error) {
          console.error('[ProductIndex] Collection fetch error:', error);
        }
      },
      
      async backgroundUpdate() {
        // Inkrementelles Update im Hintergrund
        try {
          const response = await fetch(
            `${window.Shopify?.routes?.root || '/'}products.json?limit=50&sort_by=updated_at`
          );
          const data = await response.json();
          
          if (data.products) {
            data.products.forEach(product => {
              this.products.set(product.id, this.processProduct(product));
            });
            this.saveToStorage();
          }
        } catch (error) {
          // Silent fail for background update
        }
      },
      
      processProduct(product) {
        // Extrahiere alle durchsuchbaren Felder
        const searchableText = [];
        const searchableFields = {};
        
        // Basis-Felder
        searchableFields.title = product.title || '';
        searchableFields.vendor = product.vendor || '';
        searchableFields.product_type = product.product_type || '';
        searchableFields.handle = product.handle || '';
        searchableFields.tags = (product.tags || []).join(' ');
        
        // Beschreibung (HTML bereinigen)
        if (product.body_html) {
          searchableFields.description = product.body_html
            .replace(/<[^>]*>/g, ' ')
            .replace(/&[^;]+;/g, ' ')
            .replace(/\s+/g, ' ')
            .trim();
        }
        
        // Varianten
        const variants = [];
        (product.variants || []).forEach(variant => {
          const v = {
            id: variant.id,
            title: variant.title,
            sku: variant.sku,
            price: variant.price,
            available: variant.available,
            option1: variant.option1,
            option2: variant.option2,
            option3: variant.option3,
            searchableText: [
              variant.title,
              variant.sku,
              variant.option1,
              variant.option2,
              variant.option3
            ].filter(Boolean).join(' ')
          };
          variants.push(v);
        });
        
        // Optionen (Farbe, Größe, Material etc.)
        const options = {};
        (product.options || []).forEach(option => {
          options[option.name.toLowerCase()] = option.values || [];
        });
        
        // Alles zusammenfügen für Volltext-Suche
        searchableText.push(
          searchableFields.title,
          searchableFields.vendor,
          searchableFields.product_type,
          searchableFields.tags,
          searchableFields.description,
          variants.map(v => v.searchableText).join(' '),
          Object.values(options).flat().join(' ')
        );
        
        return {
          id: product.id,
          handle: product.handle,
          title: product.title,
          vendor: product.vendor,
          product_type: product.product_type,
          tags: product.tags || [],
          price: product.variants?.[0]?.price,
          compare_at_price: product.variants?.[0]?.compare_at_price,
          available: product.variants?.some(v => v.available),
          featured_image: product.images?.[0] || product.featured_image,
          variants: variants,
          options: options,
          searchableFields: searchableFields,
          fullText: searchableText.join(' ').toLowerCase(),
          // Für Metafield-Matching später
          metafieldsLoaded: false,
          metafields: {}
        };
      },
      
      async loadProductMetafields(productHandle) {
        // Lädt Metafields für ein spezifisches Produkt
        try {
          const response = await fetch(
            `${window.Shopify?.routes?.root || '/'}products/${productHandle}.json`
          );
          const data = await response.json();
          
          if (data.product && data.product.metafields) {
            const product = this.products.get(data.product.id);
            if (product) {
              product.metafields = data.product.metafields;
              product.metafieldsLoaded = true;
              
              // Update fullText mit Metafields
              const metafieldText = this.extractMetafieldText(data.product.metafields);
              product.fullText += ' ' + metafieldText.toLowerCase();
            }
          }
        } catch (error) {
          // Silent fail
        }
      },
      
      extractMetafieldText(metafields) {
        const texts = [];
        
        const processValue = (value) => {
          if (typeof value === 'string') return value;
          if (typeof value === 'number') return String(value);
          if (Array.isArray(value)) return value.map(processValue).join(' ');
          if (typeof value === 'object' && value !== null) {
            return Object.values(value).map(processValue).join(' ');
          }
          return '';
        };
        
        if (Array.isArray(metafields)) {
          metafields.forEach(mf => {
            texts.push(mf.key || '');
            texts.push(processValue(mf.value));
          });
        } else if (typeof metafields === 'object') {
          Object.entries(metafields).forEach(([namespace, fields]) => {
            if (typeof fields === 'object') {
              Object.entries(fields).forEach(([key, value]) => {
                texts.push(key);
                texts.push(processValue(value));
              });
            }
          });
        }
        
        return texts.join(' ');
      },
      
      saveToStorage() {
        try {
          const data = {
            products: Object.fromEntries(this.products),
            lastUpdate: this.lastUpdate
          };
          localStorage.setItem('baumarkt_product_index', JSON.stringify(data));
        } catch (error) {
          // Storage full or not available
          console.warn('[ProductIndex] Storage save failed');
        }
      },
      
      loadFromStorage() {
        try {
          const data = localStorage.getItem('baumarkt_product_index');
          if (data) {
            const parsed = JSON.parse(data);
            // Check if cache is still valid (max 1 hour)
            if (Date.now() - parsed.lastUpdate < 1000 * 60 * 60) {
              return parsed;
            }
          }
        } catch (error) {
          // Storage error
        }
        return null;
      },
      
      search(query) {
        // Schnelle Volltextsuche über den Index
        const qLower = query.toLowerCase();
        const results = [];
        
        this.products.forEach(product => {
          if (product.fullText.includes(qLower)) {
            results.push(product);
          }
        });
        
        return results;
      }
    };
    
    // Initialisiere Produkt-Index
    productIndex.init();
    
    // ╔════════════════════════════════════════════════════════════════╗
    // ║  PHASE 3: MULTI-FIELD DEEP MATCHING                            ║
    // ╚════════════════════════════════════════════════════════════════╝
    
    function deepMatchProduct(product, parsedQuery) {
      let score = 0;
      const matches = {
        title: false,
        description: false,
        tags: false,
        variants: false,
        dimensions: false,
        properties: false,
        materials: false,
        colors: false,
        usage: false,
        metafields: false
      };
      
      const fullText = product.fullText || '';
      const titleLower = (product.title || '').toLowerCase();
      
      // ===== KEYWORD MATCHING =====
      parsedQuery.keywords.forEach(keyword => {
        const kw = keyword.toLowerCase();
        const kwStem = germanStem(kw);
        
        // Titel (höchste Priorität)
        if (titleLower.includes(kw)) {
          score += 100;
          matches.title = true;
        } else if (titleLower.split(/[\s\-_]+/).some(w => germanStem(w) === kwStem)) {
          score += 80;
          matches.title = true;
        }
        
        // Volltextsuche (inkl. Beschreibung, Tags, Varianten)
        if (fullText.includes(kw)) {
          score += 30;
          if (product.searchableFields?.description?.toLowerCase().includes(kw)) {
            matches.description = true;
          }
          if (product.searchableFields?.tags?.toLowerCase().includes(kw)) {
            matches.tags = true;
          }
        }
        
        // Varianten
        if (product.variants) {
          product.variants.forEach(variant => {
            if (variant.searchableText?.toLowerCase().includes(kw)) {
              score += 20;
              matches.variants = true;
            }
            // SKU Match
            if (variant.sku?.toLowerCase().includes(kw)) {
              score += 50;
              matches.variants = true;
            }
          });
        }
      });
      
      // ===== EXPANDED TERMS (Synonyme) =====
      parsedQuery.expandedTerms.forEach(term => {
        if (fullText.includes(term.toLowerCase())) {
          score += 15;
        }
      });
      
      // ===== DIMENSION MATCHING =====
      if (parsedQuery.dimensions) {
        const dimMatch = matchDimensions(product, parsedQuery.dimensions);
        if (dimMatch.score > 0) {
          score += dimMatch.score;
          matches.dimensions = true;
        }
      }
      
      // Einzelne Maße
      parsedQuery.measurements.forEach(measurement => {
        if (matchMeasurement(product, measurement)) {
          score += 25;
          matches.dimensions = true;
        }
      });
      
      // ===== PROPERTY MATCHING =====
      parsedQuery.properties.forEach(prop => {
        const propSynonyms = [prop, ...findBaumarktSynonyms(prop)];
        propSynonyms.forEach(syn => {
          if (fullText.includes(syn.toLowerCase())) {
            score += 40;
            matches.properties = true;
          }
        });
      });
      
      // ===== MATERIAL MATCHING =====
      parsedQuery.materials.forEach(mat => {
        const matSynonyms = [mat, ...findBaumarktSynonyms(mat)];
        matSynonyms.forEach(syn => {
          if (fullText.includes(syn.toLowerCase()) || titleLower.includes(syn.toLowerCase())) {
            score += 35;
            matches.materials = true;
          }
        });
      });
      
      // ===== COLOR MATCHING =====
      parsedQuery.colors.forEach(color => {
        const colorSynonyms = [color, ...(BAUMARKT_SYNONYMS.farben[color] || [])];
        
        // Check title
        if (colorSynonyms.some(c => titleLower.includes(c.toLowerCase()))) {
          score += 30;
          matches.colors = true;
        }
        
        // Check options (Varianten-Farben)
        if (product.options?.farbe || product.options?.color || product.options?.colour) {
          const colorOptions = product.options.farbe || product.options.color || product.options.colour || [];
          if (colorSynonyms.some(c => colorOptions.some(opt => opt.toLowerCase().includes(c.toLowerCase())))) {
            score += 25;
            matches.colors = true;
          }
        }
        
        // Check tags
        if (product.tags?.some(tag => colorSynonyms.some(c => tag.toLowerCase().includes(c.toLowerCase())))) {
          score += 20;
          matches.colors = true;
        }
      });
      
      // ===== USAGE MATCHING =====
      parsedQuery.usage.forEach(use => {
        const useSynonyms = [use, ...findBaumarktSynonyms(use)];
        useSynonyms.forEach(syn => {
          if (fullText.includes(syn.toLowerCase())) {
            score += 30;
            matches.usage = true;
          }
        });
      });
      
      // ===== PRODUCT TYPE MATCHING =====
      if (parsedQuery.productType) {
        const typeSynonyms = [parsedQuery.productType, ...(BAUMARKT_SYNONYMS.produkttypen[parsedQuery.productType] || [])];
        if (typeSynonyms.some(t => titleLower.includes(t.toLowerCase()))) {
          score += 50;
        }
        if (product.product_type && typeSynonyms.some(t => product.product_type.toLowerCase().includes(t.toLowerCase()))) {
          score += 40;
        }
      }
      
      // ===== METAFIELD MATCHING =====
      if (product.metafields && Object.keys(product.metafields).length > 0) {
        const metafieldText = productIndex.extractMetafieldText(product.metafields).toLowerCase();
        
        parsedQuery.keywords.forEach(kw => {
          if (metafieldText.includes(kw.toLowerCase())) {
            score += 25;
            matches.metafields = true;
          }
        });
        
        // Dimension matching in metafields
        if (parsedQuery.dimensions) {
          const dimStrings = [
            String(parsedQuery.dimensions.length),
            String(parsedQuery.dimensions.width),
            String(parsedQuery.dimensions.thickness)
          ].filter(Boolean);
          
          dimStrings.forEach(dim => {
            if (metafieldText.includes(dim)) {
              score += 15;
              matches.metafields = true;
            }
          });
        }
      }
      
      // ===== AVAILABILITY BONUS =====
      if (product.available) {
        score *= 1.1;
      }
      
      // ===== CALCULATE MATCH QUALITY =====
      const matchCount = Object.values(matches).filter(Boolean).length;
      const matchQuality = matchCount / Object.keys(matches).length;
      
      return {
        score,
        matches,
        matchQuality,
        matchCount
      };
    }
    
    function matchDimensions(product, dimensions) {
      // Versuche Dimensionen im Produkt zu finden und zu matchen
      let score = 0;
      const tolerance = 0.05; // 5% Toleranz
      
      const fullText = product.fullText || '';
      
      // Suche nach Dimensionsmustern im Produkt
      const dimPatterns = [
        /(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)\s*(mm|cm|m)?/gi,
        /(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)\s*(mm|cm|m)?/gi,
        /(\d+(?:[.,]\d+)?)\s*(mm|cm|m)\s*(lang|breit|dick|stark|stärke)/gi
      ];
      
      // Einfacher Check: Sind die Dimensionswerte im Text?
      if (dimensions.length) {
        const lengthStr = String(Math.round(dimensions.length));
        if (fullText.includes(lengthStr)) {
          score += 30;
        }
      }
      
      if (dimensions.width) {
        const widthStr = String(Math.round(dimensions.width));
        if (fullText.includes(widthStr)) {
          score += 25;
        }
      }
      
      if (dimensions.thickness) {
        const thickStr = String(Math.round(dimensions.thickness));
        if (fullText.includes(thickStr)) {
          score += 20;
        }
      }
      
      return { score };
    }
    
    function matchMeasurement(product, measurement) {
      const fullText = product.fullText || '';
      const value = measurement.normalizedMM;
      
      // Verschiedene Einheiten-Darstellungen checken
      const valuesToCheck = [
        String(value) + 'mm',
        String(value / 10) + 'cm',
        String(value / 1000) + 'm',
        String(value),
        String(Math.round(value)),
        String(measurement.value) + measurement.unit
      ];
      
      return valuesToCheck.some(v => fullText.includes(v.toLowerCase()));
    }
    
    // ╔════════════════════════════════════════════════════════════════╗
    // ║  HAUPTFUNKTION: BAUMARKT-SUCHE                                 ║
    // ╚════════════════════════════════════════════════════════════════╝
    
    async function performBaumarktSearch(query) {
      // 1. Query parsen
      const parsedQuery = parseBaumarktQuery(query);
      console.log('[BaumarktSearch] Parsed:', parsedQuery);
      
      // 2. Schnelle Shopify-Suche für initiale Ergebnisse
      const shopifyResults = [];
      
      // 3. Lokaler Index durchsuchen (falls geladen)
      const indexResults = [];
      if (productIndex.isInitialized) {
        productIndex.products.forEach(product => {
          const matchResult = deepMatchProduct(product, parsedQuery);
          if (matchResult.score > 0) {
            indexResults.push({
              ...product,
              _relevanceScore: matchResult.score,
              _matches: matchResult.matches,
              _matchQuality: matchResult.matchQuality
            });
          }
        });
        
        // Sortiere nach Score
        indexResults.sort((a, b) => b._relevanceScore - a._relevanceScore);
      }
      
      return {
        parsedQuery,
        results: indexResults.slice(0, 50),
        totalMatches: indexResults.length
      };
    }
    
    // ========== PHONETIC SEARCH (Kölner Phonetik) ==========
    // Optimized for German language - finds "Meier", "Meyer", "Maier" etc.
    function koelnerPhonetik(word) {
      if (!word || word.length === 0) return '';
      let w = word.toLowerCase()
        .replace(/ä/g, 'a').replace(/ö/g, 'o').replace(/ü/g, 'u').replace(/ß/g, 'ss')
        .replace(/ph/g, 'f').replace(/[^a-z]/g, '');
      if (w.length === 0) return '';
      
      const rules = [
        [/[aeiouäöüjy]/g, '0'],
        [/[bp]/g, '1'], [/[dt]/g, '2'], [/[fvw]/g, '3'],
        [/[gkq]/g, '4'], [/l/g, '5'], [/[mn]/g, '6'],
        [/r/g, '7'], [/[szß]/g, '8'], [/[cx]/g, '48'],
        [/h/g, '']
      ];
      
      let code = w;
      rules.forEach(([pattern, replacement]) => {
        code = code.replace(pattern, replacement);
      });
      
      // Remove consecutive duplicates
      code = code.replace(/(.)\1+/g, '$1');
      // Remove leading zeros except if only zeros
      code = code.replace(/^0+/, '') || '0';
      
      return code.substring(0, 8);
    }
    
    // ========== N-GRAM MATCHING ==========
    // Generates trigrams for partial word matching
    function generateNgrams(str, n = 3) {
      const s = str.toLowerCase().replace(/\s+/g, ' ').trim();
      if (s.length < n) return [s];
      const ngrams = [];
      for (let i = 0; i <= s.length - n; i++) {
        ngrams.push(s.substring(i, i + n));
      }
      return ngrams;
    }
    
    function ngramSimilarity(str1, str2, n = 3) {
      const ngrams1 = new Set(generateNgrams(str1, n));
      const ngrams2 = new Set(generateNgrams(str2, n));
      if (ngrams1.size === 0 || ngrams2.size === 0) return 0;
      
      let intersection = 0;
      ngrams1.forEach(ng => { if (ngrams2.has(ng)) intersection++; });
      
      return (2 * intersection) / (ngrams1.size + ngrams2.size);
    }
    
    // ========== GERMAN STEMMING (Simplified) ==========
    // Removes common German suffixes for better matching
    function germanStem(word) {
      if (!word || word.length < 4) return word.toLowerCase();
      let w = word.toLowerCase()
        .replace(/ä/g, 'a').replace(/ö/g, 'o').replace(/ü/g, 'u').replace(/ß/g, 'ss');
      
      // Common German suffixes (order matters - longest first)
      const suffixes = [
        'ungen', 'heit', 'keit', 'lich', 'isch', 'ern', 'end',
        'ung', 'ien', 'nen', 'ten', 'sen', 'est', 'ens',
        'en', 'er', 'es', 'em', 'st', 'ig', 'nd', 'te',
        'e', 's', 'n'
      ];
      
      for (const suffix of suffixes) {
        if (w.length > suffix.length + 2 && w.endsWith(suffix)) {
          return w.slice(0, -suffix.length);
        }
      }
      return w;
    }
    
    // ========== INTENT DETECTION ==========
    // Detects user intent from query (price, size, sorting)
    function detectSearchIntent(query) {
      const q = query.toLowerCase();
      const intents = {
        wantsLowPrice: false,
        wantsHighPrice: false,
        priceMax: null,
        priceMin: null,
        wantsNew: false,
        wantsSize: null,
        wantsSale: false,
        wantsAvailable: false,
        cleanQuery: query
      };
      
      // Price intents
      if (/günstig|billig|preiswert|budget|sparen/i.test(q)) {
        intents.wantsLowPrice = true;
      }
      if (/premium|luxus|hochwertig|teuer/i.test(q)) {
        intents.wantsHighPrice = true;
      }
      if (/sale|rabatt|angebot|reduziert|aktion/i.test(q)) {
        intents.wantsSale = true;
      }
      
      // Price extraction: "unter 50€", "bis 100 euro", "max 200"
      const priceMaxMatch = q.match(/(?:unter|bis|max(?:imal)?|<)\s*(\d+)\s*(?:€|euro|eur)?/i);
      if (priceMaxMatch) {
        intents.priceMax = parseInt(priceMaxMatch[1]);
        intents.cleanQuery = q.replace(priceMaxMatch[0], '').trim();
      }
      
      const priceMinMatch = q.match(/(?:ab|über|min(?:destens)?|>)\s*(\d+)\s*(?:€|euro|eur)?/i);
      if (priceMinMatch) {
        intents.priceMin = parseInt(priceMinMatch[1]);
        intents.cleanQuery = intents.cleanQuery.replace(priceMinMatch[0], '').trim();
      }
      
      // New/Latest
      if (/\b(neu|neue|neues|new|aktuell|neuheit|neuheiten)\b/i.test(q)) {
        intents.wantsNew = true;
        intents.cleanQuery = intents.cleanQuery.replace(/\b(neu|neue|neues|new|aktuell|neuheit|neuheiten)\b/gi, '').trim();
      }
      
      // Size intents
      const sizePatterns = {
        small: /\b(klein|kleine|kleines|small|xs|s)\b/i,
        medium: /\b(mittel|mittlere|medium|m)\b/i,
        large: /\b(groß|große|großes|gross|large|xl|l|xxl)\b/i
      };
      
      for (const [size, pattern] of Object.entries(sizePatterns)) {
        if (pattern.test(q)) {
          intents.wantsSize = size;
          break;
        }
      }
      
      // Availability
      if (/\b(verfügbar|lieferbar|auf lager|sofort|available)\b/i.test(q)) {
        intents.wantsAvailable = true;
      }
      
      // Clean up query - remove filler words
      intents.cleanQuery = intents.cleanQuery
        .replace(/\b(und|oder|mit|für|in|aus|von|zum|zur)\b/gi, '')
        .replace(/\s+/g, ' ')
        .trim();
      
      return intents;
    }
    
    // ========== COMPOUND WORD SPLITTING (German) ==========
    // Splits German compound words: "Holzschreibtisch" → ["Holz", "Schreibtisch"]
    function splitCompoundWord(word) {
      if (!word || word.length < 6) return [word];
      const w = word.toLowerCase();
      const parts = [];
      
      // Common German compound connectors
      const connectors = ['s', 'n', 'en', 'er', 'e', 'es'];
      
      // Known word components (expanded)
      const knownWords = new Set([
        'holz', 'tisch', 'schreib', 'stuhl', 'lampe', 'licht', 'bett', 'schrank',
        'regal', 'sofa', 'sessel', 'bank', 'kommode', 'spiegel', 'teppich',
        'vorhang', 'kissen', 'decke', 'matratze', 'boden', 'wand', 'decken',
        'steh', 'hänge', 'wohn', 'schlaf', 'kinder', 'büro', 'garten', 'küchen',
        'bad', 'ess', 'arbeits', 'platte', 'brett', 'massiv', 'eiche', 'buche',
        'kiefer', 'nuss', 'ahorn', 'birke', 'fichte', 'esche', 'kirsch',
        'schwarz', 'weiß', 'grau', 'braun', 'natur', 'dunkel', 'hell',
        'klein', 'groß', 'mittel', 'mini', 'maxi', 'rund', 'eckig', 'oval'
      ]);
      
      // Try to find valid splits
      for (let i = 3; i < w.length - 2; i++) {
        const left = w.slice(0, i);
        let right = w.slice(i);
        
        // Check if left part is a known word
        if (knownWords.has(left)) {
          // Check for connector removal
          for (const conn of connectors) {
            if (right.startsWith(conn) && right.length > conn.length + 2) {
              const rightWithoutConn = right.slice(conn.length);
              if (knownWords.has(rightWithoutConn) || rightWithoutConn.length >= 4) {
                parts.push(left, rightWithoutConn);
                return parts;
              }
            }
          }
          // Direct split
          if (knownWords.has(right) || right.length >= 4) {
            parts.push(left, right);
            return parts;
          }
        }
      }
      
      return [word];
    }
    
    // ========== KEYBOARD TYPO DETECTION ==========
    // Detects likely keyboard typos based on key proximity
    const keyboardLayout = {
      'q': ['w', 'a', '1', '2'],
      'w': ['q', 'e', 's', 'a', '2', '3'],
      'e': ['w', 'r', 'd', 's', '3', '4'],
      'r': ['e', 't', 'f', 'd', '4', '5'],
      't': ['r', 'z', 'g', 'f', '5', '6'],
      'z': ['t', 'u', 'h', 'g', '6', '7'],
      'u': ['z', 'i', 'j', 'h', '7', '8'],
      'i': ['u', 'o', 'k', 'j', '8', '9'],
      'o': ['i', 'p', 'l', 'k', '9', '0'],
      'p': ['o', 'ü', 'ö', 'l', '0', 'ß'],
      'a': ['q', 'w', 's', 'y', '<'],
      's': ['w', 'e', 'd', 'a', 'x', 'y'],
      'd': ['e', 'r', 'f', 's', 'c', 'x'],
      'f': ['r', 't', 'g', 'd', 'v', 'c'],
      'g': ['t', 'z', 'h', 'f', 'b', 'v'],
      'h': ['z', 'u', 'j', 'g', 'n', 'b'],
      'j': ['u', 'i', 'k', 'h', 'm', 'n'],
      'k': ['i', 'o', 'l', 'j', ',', 'm'],
      'l': ['o', 'p', 'ö', 'k', '.', ','],
      'y': ['a', 's', 'x', '<'],
      'x': ['s', 'd', 'c', 'y'],
      'c': ['d', 'f', 'v', 'x'],
      'v': ['f', 'g', 'b', 'c'],
      'b': ['g', 'h', 'n', 'v'],
      'n': ['h', 'j', 'm', 'b'],
      'm': ['j', 'k', ',', 'n'],
      'ä': ['ö', 'ü', 'p', "'"],
      'ö': ['ä', 'l', 'p', '-'],
      'ü': ['ä', 'p', '+', '0']
    };
    
    function isKeyboardTypo(char1, char2) {
      const c1 = char1.toLowerCase();
      const c2 = char2.toLowerCase();
      return keyboardLayout[c1]?.includes(c2) || keyboardLayout[c2]?.includes(c1);
    }
    
    function keyboardDistance(word1, word2) {
      if (Math.abs(word1.length - word2.length) > 2) return Infinity;
      
      const w1 = word1.toLowerCase();
      const w2 = word2.toLowerCase();
      let typos = 0;
      
      const longer = w1.length >= w2.length ? w1 : w2;
      const shorter = w1.length < w2.length ? w1 : w2;
      
      let j = 0;
      for (let i = 0; i < longer.length && j < shorter.length; i++) {
        if (longer[i] !== shorter[j]) {
          if (isKeyboardTypo(longer[i], shorter[j])) {
            typos += 0.5; // Keyboard typo counts as half
          } else {
            typos += 1;
          }
          // Handle insertions/deletions
          if (longer.length > shorter.length && longer[i + 1] === shorter[j]) {
            i++; // Skip extra character
          }
        }
        j++;
      }
      
      return typos + Math.abs(longer.length - shorter.length);
    }
    
    // ========== STOP WORDS HANDLING ==========
    // German stop words to ignore in search
    const GERMAN_STOP_WORDS = new Set([
      'der', 'die', 'das', 'den', 'dem', 'des', 'ein', 'eine', 'einer', 'einem', 'einen',
      'und', 'oder', 'aber', 'wenn', 'weil', 'denn', 'dass', 'als', 'wie', 'so',
      'für', 'mit', 'bei', 'nach', 'zu', 'zur', 'zum', 'von', 'vom', 'im', 'in', 'an', 'am',
      'auf', 'aus', 'durch', 'über', 'unter', 'vor', 'hinter', 'neben', 'zwischen',
      'ich', 'du', 'er', 'sie', 'es', 'wir', 'ihr', 'sie', 'mein', 'dein', 'sein', 'ihr',
      'nicht', 'auch', 'nur', 'noch', 'schon', 'sehr', 'mehr', 'immer', 'wieder',
      'hier', 'dort', 'da', 'wo', 'was', 'wer', 'wann', 'warum', 'wie',
      'alle', 'alles', 'andere', 'anderer', 'anderes', 'jeder', 'jede', 'jedes',
      'kann', 'will', 'soll', 'muss', 'darf', 'mag', 'wollen', 'können', 'werden',
      'haben', 'sein', 'ist', 'sind', 'war', 'waren', 'wird', 'wurde', 'werden',
      'suche', 'suchen', 'brauche', 'brauchen', 'möchte', 'möchten', 'kaufen', 'bestellen'
    ]);
    
    function removeStopWords(query) {
      return query
        .split(/\s+/)
        .filter(word => !GERMAN_STOP_WORDS.has(word.toLowerCase()) && word.length > 1)
        .join(' ');
    }
    
    function getSignificantWords(query) {
      return query
        .toLowerCase()
        .split(/\s+/)
        .filter(word => !GERMAN_STOP_WORDS.has(word) && word.length > 2);
    }
    
    // ========== QUERY EXPANSION ==========
    // Automatically expands query with related terms
    function expandQuery(query) {
      const expansions = new Set([query.toLowerCase()]);
      const words = getSignificantWords(query);
      
      words.forEach(word => {
        // Add compound word parts
        const parts = splitCompoundWord(word);
        if (parts.length > 1) {
          parts.forEach(p => expansions.add(p));
          expansions.add(parts.join(' '));
        }
        
        // Add stemmed version
        const stemmed = germanStem(word);
        if (stemmed !== word && stemmed.length > 2) {
          expansions.add(stemmed);
        }
        
        // Add phonetic matches from shop dictionary
        const wordPhonetic = koelnerPhonetik(word);
        shopDictionary.words.forEach(dictWord => {
          if (koelnerPhonetik(dictWord) === wordPhonetic && dictWord !== word) {
            expansions.add(dictWord);
          }
        });
      });
      
      return [...expansions];
    }
    
    // ========== FUZZY PREFIX MATCHING ==========
    // Allows typos even at the beginning of words
    function fuzzyPrefixMatch(query, target, maxErrors = 1) {
      const q = query.toLowerCase();
      const t = target.toLowerCase();
      
      if (t.startsWith(q)) return { match: true, score: 1.0 };
      if (q.length < 3) return { match: false, score: 0 };
      
      // Check with keyboard typos
      for (let i = 0; i < Math.min(q.length, t.length); i++) {
        let errors = 0;
        let matched = 0;
        
        for (let j = 0; j < q.length && i + j < t.length; j++) {
          if (q[j] === t[i + j]) {
            matched++;
          } else if (isKeyboardTypo(q[j], t[i + j])) {
            errors += 0.5;
            matched++;
          } else {
            errors++;
          }
          if (errors > maxErrors) break;
        }
        
        if (errors <= maxErrors && matched >= q.length * 0.7) {
          return { match: true, score: (1 - errors / q.length) * 0.9 };
        }
      }
      
      return { match: false, score: 0 };
    }
    
    // ========== SMART RESULT GROUPING ==========
    // Groups similar products to show variety
    function groupSimilarProducts(products, maxPerGroup = 3) {
      const groups = new Map();
      
      products.forEach(product => {
        // Create group key from product type + first significant word
        const type = product.product_type?.toLowerCase() || 'other';
        const firstWord = (product.title?.split(/\s+/)[0] || '').toLowerCase();
        const groupKey = `${type}-${germanStem(firstWord)}`;
        
        if (!groups.has(groupKey)) {
          groups.set(groupKey, []);
        }
        groups.get(groupKey).push(product);
      });
      
      // Flatten groups, taking max from each
      const result = [];
      const groupArrays = [...groups.values()];
      let round = 0;
      
      while (result.length < products.length) {
        let added = false;
        for (const group of groupArrays) {
          if (round < group.length && round < maxPerGroup) {
            result.push(group[round]);
            added = true;
          }
        }
        if (!added) break;
        round++;
      }
      
      return result;
    }
    
    // ========== MULTI-WORD QUERY HANDLING ==========
    // Handles queries with multiple words intelligently
    function analyzeMultiWordQuery(query) {
      const words = getSignificantWords(query);
      
      if (words.length <= 1) {
        return { type: 'single', words, mustMatch: words, shouldMatch: [] };
      }
      
      // Categorize words
      const colorWords = new Set(Object.keys(FUZZY_DICTIONARY?.colors || {}));
      const sizeWords = new Set(['klein', 'small', 'mittel', 'medium', 'groß', 'gross', 'large', 'xl', 's', 'm', 'l', 'xxl']);
      const materialWords = new Set(Object.keys(FUZZY_DICTIONARY?.materials || {}));
      
      const analysis = {
        type: 'multi',
        words,
        mustMatch: [],   // Product must match these
        shouldMatch: [], // Nice to have
        colors: [],
        sizes: [],
        materials: [],
        productWords: []
      };
      
      words.forEach(word => {
        if (colorWords.has(word)) {
          analysis.colors.push(word);
          analysis.shouldMatch.push(word);
        } else if (sizeWords.has(word)) {
          analysis.sizes.push(word);
          analysis.shouldMatch.push(word);
        } else if (materialWords.has(word)) {
          analysis.materials.push(word);
          analysis.shouldMatch.push(word);
        } else {
          analysis.productWords.push(word);
          analysis.mustMatch.push(word);
        }
      });
      
      // If no must-match words, use first significant word
      if (analysis.mustMatch.length === 0 && words.length > 0) {
        analysis.mustMatch.push(words[0]);
      }
      
      return analysis;
    }
    
    // ========== ADVANCED RELEVANCE CALCULATION ==========
    // Calculates match quality with multiple factors
    function calculateMatchQuality(product, queryAnalysis) {
      let quality = 0;
      const title = (product.title || '').toLowerCase();
      const titleWords = title.split(/[\s\-_\/]+/);
      
      // Must-match words (high weight)
      queryAnalysis.mustMatch.forEach(word => {
        const stem = germanStem(word);
        if (title.includes(word)) {
          quality += 100;
        } else if (titleWords.some(tw => germanStem(tw) === stem)) {
          quality += 80;
        } else if (titleWords.some(tw => ngramSimilarity(tw, word) > 0.6)) {
          quality += 50;
        } else {
          quality -= 20; // Penalty for missing must-match
        }
      });
      
      // Should-match words (moderate weight)
      queryAnalysis.shouldMatch.forEach(word => {
        if (title.includes(word)) {
          quality += 30;
        } else {
          // Check tags and variants
          const tags = (product.tags || []).join(' ').toLowerCase();
          const variants = (product.variants || []).map(v => v.title).join(' ').toLowerCase();
          if (tags.includes(word) || variants.includes(word)) {
            quality += 20;
          }
        }
      });
      
      // Position bonus (word appears early in title)
      queryAnalysis.mustMatch.forEach(word => {
        const pos = title.indexOf(word);
        if (pos === 0) quality += 20;
        else if (pos > 0 && pos < 10) quality += 10;
      });
      
      // Exact phrase bonus
      const phrase = queryAnalysis.words.join(' ');
      if (title.includes(phrase)) {
        quality += 50;
      }
      
      return quality;
    }
    
    // ========== DYNAMIC SHOP DICTIONARY ==========
    // Builds vocabulary from shop products for better matching
    const shopDictionary = {
      words: new Set(),
      productTitles: [],
      initialized: false,
      
      async init() {
        if (this.initialized) return;
        
        try {
          // Fetch popular products to build dictionary
          const response = await fetch(
            `${window.Shopify?.routes?.root || '/'}search/suggest.json?q=*&resources[type]=product&resources[limit]=50`
          );
          const data = await response.json();
          const products = data?.resources?.results?.products || [];
          
          products.forEach(p => {
            // Add title words
            const titleWords = p.title.toLowerCase().split(/[\s\-_\/]+/);
            titleWords.forEach(w => {
              if (w.length >= 3) this.words.add(w);
            });
            this.productTitles.push(p.title.toLowerCase());
            
            // Add vendor
            if (p.vendor) this.words.add(p.vendor.toLowerCase());
            
            // Add product type
            if (p.product_type) {
              p.product_type.toLowerCase().split(/[\s\-_\/]+/).forEach(w => {
                if (w.length >= 3) this.words.add(w);
              });
            }
          });
          
          this.initialized = true;
          console.log(`[Search] Shop dictionary initialized: ${this.words.size} words`);
        } catch (e) {
          console.warn('[Search] Failed to init shop dictionary:', e);
        }
      },
      
      findSimilar(query, maxResults = 5) {
        if (!this.initialized || this.words.size === 0) return [];
        
        const qLower = query.toLowerCase();
        const qPhonetic = koelnerPhonetik(query);
        const qStem = germanStem(query);
        const results = [];
        
        this.words.forEach(word => {
          // Skip if same
          if (word === qLower) return;
          
          let score = 0;
          
          // Phonetic match
          if (koelnerPhonetik(word) === qPhonetic && qPhonetic.length > 1) {
            score += 0.4;
          }
          
          // Stem match
          if (germanStem(word) === qStem && qStem.length > 2) {
            score += 0.3;
          }
          
          // N-gram similarity
          const ngramScore = ngramSimilarity(word, qLower);
          score += ngramScore * 0.3;
          
          // Starts with same chars
          if (word.startsWith(qLower.substring(0, 2))) {
            score += 0.1;
          }
          
          if (score > 0.3) {
            results.push({ word, score });
          }
        });
        
        return results
          .sort((a, b) => b.score - a.score)
          .slice(0, maxResults)
          .map(r => r.word);
      }
    };
    
    // Initialize shop dictionary in background
    shopDictionary.init();

    const SEARCH_CONFIG = {
      fieldWeights: {
        title: 100,
        sku: 90,
        barcode: 90,
        vendor: 50,
        product_type: 40,
        tags: 35,
        variant_title: 30,
        handle: 25,
        body: 20,
        collection: 15,
        metafields: {
          'custom.material': 45,
          'custom.farbe': 40,
          'custom.groesse': 35,
          'custom.keywords': 60,
          'custom.synonyme': 55,
          'custom.artikelnummer': 85,
          'seo.description': 20
        }
      },
      boosts: {
        exactMatch: 2.0,
        startsWithQuery: 1.5,
        inStock: 1.3,
        onSale: 1.1,
        hasImage: 1.05,
        recentlyViewed: 1.2,
        bestSeller: 1.4
      },
      customSynonyms: {
        'folie': ['film', 'schutzfolie', 'displayschutz', 'panzerfolie'],
        'holz': ['wood', 'timber', 'lumber', 'holzplatte', 'sperrholz', 'mdf', 'spanplatte'],
        'platte': ['board', 'panel', 'brett', 'scheibe'],
        'zuschnitt': ['cut', 'cutting', 'maßzuschnitt', 'custom cut'],
        'meterware': ['by the meter', 'laufmeter', 'rollware'],
        'beschichtung': ['coating', 'finish', 'oberfläche', 'versiegelung'],
        'stärke': ['thickness', 'dicke', 'materialstärke'],
        'kante': ['edge', 'rand', 'umleimer', 'kantenschutz']
      },
      skuPatterns: [
        /^[A-Z]{2,4}[-_]?\d{3,}/i,
        /^\d{5,}/,
        /^[A-Z0-9]{6,12}$/i
      ],
      cache: {
        enabled: true,
        maxEntries: 100,
        ttlMs: 5 * 60 * 1000,
        storageKey: 'cstm_search_cache_v3'
      },
      limits: {
        maxResults: 12,
        maxVariantsShown: 6,
        maxSearchVariants: 20,
        debounceMs: 250,
        minQueryLength: 2
      },
      analytics: {
        enabled: false,
        trackSearches: true,
        trackClicks: true,
        trackNoResults: true
      }
    };
    
    // ========== SEARCH CACHE ==========
    const searchCache = {
      data: new Map(),
      
      init() {
        if (!SEARCH_CONFIG.cache.enabled) return;
        try {
          const stored = sessionStorage.getItem(SEARCH_CONFIG.cache.storageKey);
          if (stored) {
            const parsed = JSON.parse(stored);
            const now = Date.now();
            Object.entries(parsed).forEach(([key, entry]) => {
              if (now - entry.timestamp < SEARCH_CONFIG.cache.ttlMs) {
                this.data.set(key, entry);
              }
            });
          }
        } catch (e) {
          console.warn('[Search] Cache load failed:', e);
        }
      },
      
      get(query) {
        if (!SEARCH_CONFIG.cache.enabled) return null;
        const key = query.toLowerCase().trim();
        const entry = this.data.get(key);
        if (entry && Date.now() - entry.timestamp < SEARCH_CONFIG.cache.ttlMs) {
          return entry.results;
        }
        return null;
      },
      
      set(query, results) {
        if (!SEARCH_CONFIG.cache.enabled) return;
        const key = query.toLowerCase().trim();
        if (this.data.size >= SEARCH_CONFIG.cache.maxEntries) {
          const oldest = [...this.data.entries()].sort((a, b) => a[1].timestamp - b[1].timestamp)[0];
          if (oldest) this.data.delete(oldest[0]);
        }
        this.data.set(key, { results, timestamp: Date.now() });
        this.persist();
      },
      
      persist() {
        try {
          const obj = {};
          this.data.forEach((value, key) => { obj[key] = value; });
          sessionStorage.setItem(SEARCH_CONFIG.cache.storageKey, JSON.stringify(obj));
        } catch (e) {
          console.warn('[Search] Cache persist failed:', e);
        }
      },
      
      clear() {
        this.data.clear();
        sessionStorage.removeItem(SEARCH_CONFIG.cache.storageKey);
      }
    };
    
    searchCache.init();
    
    // ========== SKU DETECTION ==========
    function looksLikeSku(query) {
      const q = query.trim();
      return SEARCH_CONFIG.skuPatterns.some(pattern => pattern.test(q));
    }
    
    // ========== ENHANCED RELEVANCE SCORING v3.0 ==========
    // Now with phonetic matching, stemming, n-gram and intent awareness
    function calculateRelevanceScore(product, query, variant = null, intent = null) {
      const weights = SEARCH_CONFIG.fieldWeights;
      const boosts = SEARCH_CONFIG.boosts;
      const queryLower = query.toLowerCase();
      const queryNorm = normalizeForComparison(query);
      const queryStem = germanStem(query);
      const queryPhonetic = koelnerPhonetik(query);
      const isSku = looksLikeSku(query);
      let score = 0;
      
      // Enhanced field checking with phonetic and stem matching
      const checkField = (value, weight, isSkuField = false) => {
        if (!value) return 0;
        const valueLower = String(value).toLowerCase();
        const valueNorm = normalizeForComparison(value);
        
        // SKU fields need stricter matching
        if (isSkuField && isSku) {
          // Exact match for SKU
          if (valueLower === queryLower || valueNorm === queryNorm) {
            return weight * boosts.exactMatch * 1.5; // Extra boost for exact SKU
          }
          // Prefix match for SKU (typing in progress)
          if (valueLower.startsWith(queryLower) || queryLower.startsWith(valueLower)) {
            return weight * boosts.startsWithQuery;
          }
          // Contains for partial SKU
          if (valueLower.includes(queryLower)) {
            return weight * 0.7;
          }
          return 0; // SKU matching is strict
        }
        
        // Standard exact match
        if (valueLower === queryLower || valueNorm === queryNorm) {
          return weight * boosts.exactMatch;
        }
        
        // Starts with query
        if (valueLower.startsWith(queryLower) || valueNorm.startsWith(queryNorm)) {
          return weight * boosts.startsWithQuery;
        }
        
        // Contains query
        if (valueLower.includes(queryLower) || valueNorm.includes(queryNorm)) {
          return weight;
        }
        
        // Fuzzy prefix match with keyboard typo tolerance
        const fuzzyResult = fuzzyPrefixMatch(queryLower, valueLower, 1);
        if (fuzzyResult.match) {
          return weight * fuzzyResult.score;
        }
        
        // Keyboard-aware distance (nearby keys are cheaper)
        const keyDist = keyboardDistance(queryLower, valueLower);
        if (keyDist <= 1.5) {
          return weight * (1 - keyDist / 3);
        }
        
        // Stem matching (holzplatten ↔ holzplatte)
        const valueStem = germanStem(value);
        if (valueStem === queryStem && queryStem.length > 2) {
          return weight * 0.9;
        }
        
        // Phonetic matching (Meier ↔ Meyer ↔ Maier)
        const valuePhonetic = koelnerPhonetik(value);
        if (valuePhonetic === queryPhonetic && queryPhonetic.length > 1) {
          return weight * 0.8;
        }
        
        // N-gram similarity for partial matches
        const ngramScore = ngramSimilarity(valueLower, queryLower);
        if (ngramScore > 0.5) {
          return weight * ngramScore * 0.7;
        }
        
        // Word-level matching
        const words = valueLower.split(/[\s\-_\/]+/);
        if (words.some(w => w === queryLower || w.startsWith(queryLower))) {
          return weight * 0.8;
        }
        
        // Check if any word stems match
        if (words.some(w => germanStem(w) === queryStem && queryStem.length > 2)) {
          return weight * 0.6;
        }
        
        // Check compound word parts
        const queryParts = splitCompoundWord(queryLower);
        if (queryParts.length > 1) {
          const matchingParts = queryParts.filter(part => 
            valueLower.includes(part) || words.some(w => germanStem(w) === germanStem(part))
          );
          if (matchingParts.length === queryParts.length) {
            return weight * 0.85; // All parts match
          } else if (matchingParts.length > 0) {
            return weight * 0.5 * (matchingParts.length / queryParts.length);
          }
        }
        
        return 0;
      };
      
      // Score title (highest priority)
      score += checkField(product.title, weights.title);
      
      // Score SKU with strict matching if query looks like SKU
      if (variant && variant.sku) {
        score += checkField(variant.sku, weights.sku, true);
      } else if (product.variants) {
        product.variants.forEach(v => {
          if (v.sku) score += checkField(v.sku, weights.sku, true) * 0.5;
        });
      }
      
      score += checkField(product.vendor, weights.vendor);
      score += checkField(product.product_type, weights.product_type);
      
      if (product.tags && Array.isArray(product.tags)) {
        product.tags.forEach(tag => {
          score += checkField(tag, weights.tags) * 0.5;
        });
      }
      
      if (variant) {
        score += checkField(variant.title, weights.variant_title);
      }
      
      score += checkField(product.handle, weights.handle);
      
      if (product.body) {
        score += checkField(product.body, weights.body);
      }
      
      // ========== INTENT-BASED BOOSTS ==========
      if (intent) {
        // Price intent boosts
        if (intent.wantsLowPrice) {
          // Boost cheaper products
          const price = parseFloat(product.price) || 0;
          if (price > 0 && price < 50) score *= 1.3;
          else if (price < 100) score *= 1.15;
        }
        
        if (intent.priceMax) {
          const price = parseFloat(product.price) || 0;
          if (price <= intent.priceMax) score *= 1.4;
          else score *= 0.5; // Penalize over-budget
        }
        
        if (intent.priceMin) {
          const price = parseFloat(product.price) || 0;
          if (price >= intent.priceMin) score *= 1.2;
          else score *= 0.7;
        }
        
        // Sale intent
        if (intent.wantsSale) {
          if (product.compare_at_price && product.compare_at_price > product.price) {
            score *= 1.5;
          }
        }
        
        // Availability intent
        if (intent.wantsAvailable) {
          if (product.available !== false) score *= 1.3;
          else score *= 0.3;
        }
        
        // New products intent
        if (intent.wantsNew) {
          if (product.tags && product.tags.some(t => 
            /neu|new|neuheit|aktuell|2024|2025|2026/i.test(t)
          )) {
            score *= 1.4;
          }
        }
      }
      
      // ========== STANDARD BOOSTS ==========
      if (product.available !== false) {
        score *= boosts.inStock;
      }
      
      if (product.compare_at_price && product.compare_at_price > product.price) {
        score *= boosts.onSale;
      }
      
      if (product.featured_image?.url) {
        score *= boosts.hasImage;
      }
      
      if (product.tags && product.tags.some(t => 
        t.toLowerCase().includes('bestseller') || 
        t.toLowerCase().includes('topseller') ||
        t.toLowerCase().includes('beliebt')
      )) {
        score *= boosts.bestSeller;
      }
      
      // ========== MULTI-WORD QUERY ANALYSIS ==========
      const queryAnalysis = analyzeMultiWordQuery(query);
      if (queryAnalysis.type === 'multi') {
        const matchQuality = calculateMatchQuality(product, queryAnalysis);
        score += matchQuality;
        
        // Boost if product matches color intent
        if (queryAnalysis.colors.length > 0) {
          const productText = [
            product.title,
            ...(product.tags || []),
            ...(product.variants || []).map(v => v.title)
          ].join(' ').toLowerCase();
          
          const colorMatches = queryAnalysis.colors.filter(c => productText.includes(c));
          if (colorMatches.length > 0) {
            score *= 1 + (0.2 * colorMatches.length);
          }
        }
        
        // Boost if product matches size intent
        if (queryAnalysis.sizes.length > 0 && product.variants) {
          const variantTitles = product.variants.map(v => v.title?.toLowerCase() || '').join(' ');
          const sizeMatches = queryAnalysis.sizes.filter(s => variantTitles.includes(s));
          if (sizeMatches.length > 0) {
            score *= 1.15;
          }
        }
      }
      
      return score;
    }
    
    // ========== SEARCH ANALYTICS ==========
    function trackSearchEvent(eventType, data) {
      if (!SEARCH_CONFIG.analytics.enabled) return;
      const event = {
        type: eventType,
        timestamp: Date.now(),
        ...data
      };
      console.log('[Search Analytics]', event);
    }
    
    // ========================================
    // SEARCH FUNCTIONALITY
    // ========================================
    const searchbar = header.querySelector('[data-searchbar]');
    const searchInput = header.querySelector('[data-search-input]');
    const searchClear = header.querySelector('[data-search-clear]');
    const searchResults = header.querySelector('[data-search-results]');
    const searchViewAll = header.querySelector('[data-search-view-all]');
    const mobileSearchToggle = header.querySelector('[data-search-mobile-toggle]');
    
    if (searchbar && searchInput && searchResults) {
      let searchTimeout;
      let currentQuery = '';
      let currentIntent = null; // Search intent detection result
      
      // ========================================
      // INTELLIGENT FUZZY SEARCH ENGINE v3.0
      // ========================================
      
      function levenshtein(a, b) {
        if (a.length === 0) return b.length;
        if (b.length === 0) return a.length;
        const matrix = [];
        for (let i = 0; i <= b.length; i++) matrix[i] = [i];
        for (let j = 0; j <= a.length; j++) matrix[0][j] = j;
        for (let i = 1; i <= b.length; i++) {
          for (let j = 1; j <= a.length; j++) {
            if (b.charAt(i - 1) === a.charAt(j - 1)) {
              matrix[i][j] = matrix[i - 1][j - 1];
            } else {
              matrix[i][j] = Math.min(
                matrix[i - 1][j - 1] + 1,
                matrix[i][j - 1] + 1,
                matrix[i - 1][j] + 1
              );
            }
          }
        }
        return matrix[b.length][a.length];
      }
      
      function findClosestMatch(input, wordList, maxDistance = 2) {
        const inputLower = input.toLowerCase();
        let closest = null;
        let closestDist = Infinity;
        
        for (const word of wordList) {
          const dist = levenshtein(inputLower, word.toLowerCase());
          if (dist < closestDist && dist <= maxDistance) {
            closestDist = dist;
            closest = word;
          }
        }
        return closest;
      }
      
      const FUZZY_DICTIONARY = {
        colors: {
          'schwarz': ['black', 'schwar', 'shwarz', 'scwarz'],
          'black': ['schwarz', 'blck', 'balck', 'blak'],
          'weiß': ['white', 'weiss', 'weis', 'wiess', 'weisss'],
          'weiss': ['white', 'weiß', 'weis', 'wiess'],
          'white': ['weiß', 'weiss', 'withe', 'whte', 'wite'],
          'rot': ['red', 'rott', 'roht'],
          'red': ['rot', 'reed', 'redd', 'rad'],
          'blau': ['blue', 'balu', 'blua', 'balau'],
          'blue': ['blau', 'bleu', 'bule', 'blu'],
          'grün': ['green', 'gruen', 'grun', 'grünn'],
          'gruen': ['green', 'grün', 'grun'],
          'green': ['grün', 'gruen', 'gren', 'gree', 'grean'],
          'gelb': ['yellow', 'geld', 'gelp'],
          'yellow': ['gelb', 'yelow', 'yello', 'yellw'],
          'orange': ['oragne', 'orang', 'ornage', 'orangee'],
          'pink': ['rosa', 'pnk', 'pnik', 'pinke'],
          'rosa': ['pink', 'roas', 'rsoa'],
          'lila': ['purple', 'violet', 'violett', 'lilla', 'liela'],
          'purple': ['lila', 'violett', 'purpel', 'pruple', 'purle'],
          'violett': ['purple', 'lila', 'violet', 'vilett', 'viollet'],
          'braun': ['brown', 'bruan', 'barun', 'brawn'],
          'brown': ['braun', 'brwon', 'bron', 'borwn'],
          'grau': ['grey', 'gray', 'silver', 'garu', 'grua'],
          'grey': ['grau', 'gray', 'gery', 'gry'],
          'gray': ['grau', 'grey', 'gry', 'garay'],
          'silber': ['silver', 'silbern', 'sibler', 'slber'],
          'silver': ['silber', 'sliver', 'silvr', 'siler'],
          'gold': ['golden', 'gol', 'glod', 'golde'],
          'golden': ['gold', 'golen', 'goldn'],
          'beige': ['bege', 'beig', 'beidge'],
          'türkis': ['turquoise', 'tuerkis', 'turkis', 'türkiss'],
          'turquoise': ['türkis', 'tuerkis', 'turqoise', 'turquise']
        },
        products: {
          // BUG 25 FIX: Replaced fashion terms with Baumarkt-relevant products
          'stegplatte': ['stegplatten', 'doppelstegplatte', 'hohlkammerplatte', 'stegplaten', 'stegplate'],
          'stegplatten': ['stegplatte', 'doppelstegplatten', 'hohlkammerplatten', 'stegplaten'],
          'wellplatte': ['wellplatten', 'welplatte', 'wellplate', 'wellblech'],
          'wellplatten': ['wellplatte', 'welplatten', 'wellplaten', 'wellbleche'],
          'fassadenplatte': ['fassadenplatten', 'fassade', 'hpl', 'fassadenplate'],
          'überdachung': ['ueberdachung', 'überdachungen', 'dach', 'vordach', 'terrassendach'],
          'carport': ['karport', 'carpot', 'caport', 'carports'],
          'dachrinne': ['dachrinnen', 'regenrinne', 'rinne', 'dachrinn'],
          'verlegesystem': ['verlegesysteme', 'montagesystem', 'befestigung', 'verlegesytem'],
          'zubehör': ['zubehoer', 'zubehor', 'zubehore', 'zubehoer'],
          'schraube': ['schrauben', 'schraub', 'schraubn'],
          'profil': ['profile', 'leiste', 'leisten', 'profl', 'profiel'],
          'platte': ['platten', 'plate', 'platen', 'brett'],
          'plane': ['planen', 'abdeckplane', 'gewebeplane', 'planne'],
          'terrassendach': ['terrasendach', 'terassendach', 'terrassenueberdachung', 'terrassendächer'],
          'gewächshaus': ['gewaechshaus', 'gewachshaus', 'treibhaus', 'gewächshäuser'],
          'scobalit': ['scobalit hr', 'skobalit', 'schobalit'],
          'gutta': ['guta', 'guttagliss', 'guttaplast']
        },
        materials: {
          'leder': ['leather', 'ledr', 'laeder'],
          'leather': ['leder', 'leater', 'lether', 'leathr'],
          'baumwolle': ['cotton', 'baumwole', 'baumwoole'],
          'cotton': ['baumwolle', 'coton', 'cottn', 'cotten'],
          'seide': ['silk', 'saide', 'siede'],
          'silk': ['seide', 'slk', 'silke'],
          'wolle': ['wool', 'wole', 'woole'],
          'wool': ['wolle', 'wol', 'woll'],
          'leinen': ['linen', 'leinenn', 'linenl'],
          'linen': ['leinen', 'linne', 'linn'],
          'kunststoff': ['plastic', 'kunstoff', 'kunsttoff'],
          'plastic': ['kunststoff', 'plastik', 'platic', 'plasitc'],
          'metall': ['metal', 'mettal', 'metatl'],
          'metal': ['metall', 'metl', 'mtal'],
          'holz': ['wood', 'holtz', 'holzz'],
          'wood': ['holz', 'wod', 'woood'],
          'glas': ['glass', 'glaz', 'glaas'],
          'glass': ['glas', 'glas', 'glss']
        },
        sizes: {
          'klein': ['small', 'klien', 'klain'],
          'small': ['klein', 'smal', 'smll', 'samll'],
          'mittel': ['medium', 'mitel', 'mittle'],
          'medium': ['mittel', 'medum', 'medim', 'meidum'],
          'groß': ['large', 'big', 'gross', 'gros', 'groos'],
          'gross': ['large', 'big', 'groß', 'gros'],
          'large': ['groß', 'gross', 'larg', 'lagre', 'lrage']
        }
      };
      
      function getAllDictionaryWords() {
        const words = new Set();
        Object.values(FUZZY_DICTIONARY).forEach(category => {
          Object.keys(category).forEach(key => {
            words.add(key);
            category[key].forEach(v => words.add(v));
          });
        });
        return [...words];
      }
      
      function findWordCorrections(word) {
        const wordLower = word.toLowerCase();
        const corrections = new Set();
        
        Object.values(FUZZY_DICTIONARY).forEach(category => {
          if (category[wordLower]) {
            category[wordLower].forEach(alt => corrections.add(alt));
          }
          
          Object.entries(category).forEach(([key, values]) => {
            if (values.includes(wordLower)) {
              corrections.add(key);
              values.forEach(v => {
                if (v !== wordLower) corrections.add(v);
              });
            }
          });
          
          Object.keys(category).forEach(key => {
            const dist = levenshtein(wordLower, key);
            const maxDist = wordLower.length <= 4 ? 1 : 2;
            if (dist > 0 && dist <= maxDist) {
              corrections.add(key);
              category[key].forEach(alt => corrections.add(alt));
            }
          });
        });
        
        return [...corrections];
      }
      
      function normalizeForComparison(str) {
        return str.toLowerCase()
          .replace(/[\s\-_\.]/g, '')
          .replace(/ä/g, 'a').replace(/ö/g, 'o').replace(/ü/g, 'u').replace(/ß/g, 'ss')
          .replace(/ae/g, 'a').replace(/oe/g, 'o').replace(/ue/g, 'u');
      }
      
      function generateSearchVariants(query) {
        const queryLower = query.toLowerCase().trim();
        const variants = new Set();
        
        variants.add(queryLower);
        
        // SKU-style queries get special handling
        if (looksLikeSku(queryLower)) {
          variants.add(queryLower.replace(/[-_\s]/g, ''));
          variants.add(queryLower.toUpperCase());
          return [...variants].slice(0, 5);
        }
        
        // ========== STOP WORD REMOVAL ==========
        const cleanQuery = removeStopWords(queryLower);
        if (cleanQuery !== queryLower && cleanQuery.length >= 2) {
          variants.add(cleanQuery);
        }
        
        // ========== COMPOUND WORD SPLITTING ==========
        const words = queryLower.split(/\s+/);
        words.forEach(word => {
          if (word.length >= 6) {
            const parts = splitCompoundWord(word);
            if (parts.length > 1) {
              // Add individual parts
              parts.forEach(p => {
                if (p.length >= 3) variants.add(p);
              });
              // Add space-separated version
              variants.add(parts.join(' '));
            }
          }
        });
        
        // ========== QUERY EXPANSION ==========
        const expanded = expandQuery(queryLower);
        expanded.slice(0, 5).forEach(exp => variants.add(exp));
        
        // ========== SYNONYM EXPANSION ==========
        const customSynonyms = SEARCH_CONFIG.customSynonyms;
        Object.entries(customSynonyms).forEach(([key, synonyms]) => {
          if (queryLower.includes(key)) {
            synonyms.slice(0, 3).forEach(syn => {
              variants.add(queryLower.replace(key, syn));
              variants.add(syn);
            });
          }
          synonyms.forEach(syn => {
            if (queryLower.includes(syn)) {
              variants.add(queryLower.replace(syn, key));
              variants.add(key);
            }
          });
        });
        
        // ========== SHOP DICTIONARY MATCHES ==========
        const shopMatches = shopDictionary.findSimilar(queryLower);
        shopMatches.slice(0, 3).forEach(match => variants.add(match));
        
        // ========== STEMMED VARIANT ==========
        const stemmed = germanStem(queryLower);
        if (stemmed !== queryLower && stemmed.length >= 3) {
          variants.add(stemmed);
          // Find words in shop dict with same stem
          shopDictionary.words.forEach(word => {
            if (germanStem(word) === stemmed && word !== queryLower) {
              variants.add(word);
            }
          });
        }
        
        // ========== SPACE HANDLING ==========
        const noSpaces = queryLower.replace(/\s+/g, '');
        if (noSpaces !== queryLower) {
          variants.add(noSpaces);
        }
        
        // ========== WORD CORRECTIONS ==========
        const correctionWords = queryLower.split(/\s+/);
        const wordCorrections = correctionWords.map(word => {
          const corrections = findWordCorrections(word);
          const customCorrections = [];
          Object.entries(customSynonyms).forEach(([key, synonyms]) => {
            if (word === key) customCorrections.push(...synonyms.slice(0, 2));
            if (synonyms.includes(word)) customCorrections.push(key);
          });
          const allCorrections = [...new Set([...corrections, ...customCorrections])];
          return allCorrections.length > 0 ? [word, ...allCorrections] : [word];
        });
        
        if (correctionWords.length === 1) {
          wordCorrections[0].forEach(w => variants.add(w));
        } else {
          wordCorrections.forEach(corrections => {
            corrections.forEach(c => {
              if (c.length >= 3) variants.add(c);
            });
          });
          
          const correctedQuery = wordCorrections.map(c => c[0] || '').join(' ');
          if (correctedQuery !== queryLower) variants.add(correctedQuery);
          
          for (let i = 0; i < correctionWords.length; i++) {
            for (const correction of wordCorrections[i].slice(0, 3)) {
              const newWords = [...correctionWords];
              newWords[i] = correction;
              variants.add(newWords.join(' '));
              variants.add(newWords.join(''));
            }
          }
        }
        
        // ========== PHONETIC VARIANT ==========
        // Find words that sound the same (Meier → Meyer)
        const queryPhonetic = koelnerPhonetik(queryLower);
        if (queryPhonetic.length >= 2) {
          shopDictionary.words.forEach(word => {
            if (koelnerPhonetik(word) === queryPhonetic && word !== queryLower) {
              variants.add(word);
            }
          });
        }
        
        // BUG 24 FIX: Transposition regex removed - was producing garbage results
        
        // ========== UMLAUT VARIANTS ==========
        let umlautVariant = queryLower;
        umlautVariant = umlautVariant.replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss');
        if (umlautVariant !== queryLower) variants.add(umlautVariant);
        
        umlautVariant = queryLower;
        umlautVariant = umlautVariant.replace(/ae/g, 'ä').replace(/oe/g, 'ö').replace(/ue/g, 'ü');
        if (umlautVariant !== queryLower) variants.add(umlautVariant);
        
        const noUmlauts = queryLower.replace(/[äöü]/g, m => ({ä:'a',ö:'o',ü:'u'})[m]);
        if (noUmlauts !== queryLower) variants.add(noUmlauts);
        
        // ========== TYPO SWAPS ==========
        // BUG 22 FIX: Only add swaps that exist in shop dictionary to avoid bloat
        for (let i = 0; i < queryLower.length - 1; i++) {
          const swapped = queryLower.slice(0, i) + queryLower[i + 1] + queryLower[i] + queryLower.slice(i + 2);
          if (shopDictionary.words.has(swapped)) {
            variants.add(swapped);
          }
        }
        
        // ========== FINAL SORT & LIMIT ==========
        const result = [...variants].filter(v => v && v.length >= 2);
        
        result.sort((a, b) => {
          if (a === queryLower) return -1;
          if (b === queryLower) return 1;
          if (a === noSpaces) return -1;
          if (b === noSpaces) return 1;
          // Prioritize shop dictionary words
          const aInShop = shopDictionary.words.has(a);
          const bInShop = shopDictionary.words.has(b);
          if (aInShop && !bInShop) return -1;
          if (bInShop && !aInShop) return 1;
          return Math.abs(a.length - queryLower.length) - Math.abs(b.length - queryLower.length);
        });
        
        const maxVariants = SEARCH_CONFIG.limits.maxSearchVariants;
        return result.slice(0, maxVariants);
      }
      
      // ── Lokaler Index als eigenstaendige Suchquelle (SKU / Compound-Woerter / Synonyme) ──
      // Die native suggest.json findet weder Art-Nummern noch Teilwoerter wie
      // "Vordach" in "Haustuervordach". Der bereits vorhandene ProductIndex kann das.
      function getLocalProductMatches(query, parsedBaumarktQuery) {
        try {
          if (!productIndex || !productIndex.isInitialized || !productIndex.products) return [];
          const qLower = (query || '').toLowerCase().trim();
          if (qLower.length < 2) return [];
          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          const scored = [];
          productIndex.products.forEach(p => {
            let score = 0;
            const titleLower = (p.title || '').toLowerCase();
            if (titleLower.includes(qLower)) score += 120;
            if (p.fullText && p.fullText.includes(qLower)) score += 40;
            if (p.variants && p.variants.some(v => v.sku && String(v.sku).toLowerCase().includes(qLower))) score += 150;
            if (p.handle && p.handle.toLowerCase().includes(qLower)) score += 30;
            if (parsedBaumarktQuery && typeof deepMatchProduct === 'function') {
              const dm = deepMatchProduct(p, parsedBaumarktQuery);
              if (dm && dm.score > 0) score += dm.score * 0.4;
            }
            if (score > 0) scored.push({ p: p, score: score });
          });
          if (!scored.length) return [];
          scored.sort((a, b) => b.score - a.score);
          return scored.slice(0, 20).map(function (entry) {
            const p = entry.p;
            let imgUrl = '';
            const fi = p.featured_image;
            if (typeof fi === 'string') imgUrl = fi;
            else if (fi && fi.src) imgUrl = fi.src;
            else if (fi && fi.url) imgUrl = fi.url;
            return {
              id: p.id,
              title: p.title,
              handle: p.handle,
              url: root + 'products/' + p.handle,
              price: p.price,
              compare_at_price: p.compare_at_price,
              available: p.available,
              product_type: p.product_type,
              featured_image: imgUrl ? { url: imgUrl, alt: p.title } : null,
              variants: (p.variants || []).map(v => ({
                id: v.id, title: v.title, sku: v.sku,
                price: v.price, compare_at_price: v.compare_at_price, available: v.available
              })),
              _localIndex: true
            };
          });
        } catch (e) {
          return [];
        }
      }

      function mergeDedupeProducts(nativeArr, localArr) {
        const seen = new Set((nativeArr || []).map(p => String(p.id)));
        const merged = (nativeArr || []).slice();
        (localArr || []).forEach(p => {
          const key = String(p.id);
          if (!seen.has(key)) { seen.add(key); merged.push(p); }
        });
        return merged;
      }

      function performSearch(query) {
        if (query.length < 2) {
          hideResults();
          return;
        }
        
        currentQuery = query;
        
        // Detect search intent early
        currentIntent = detectSearchIntent(query);
        
        // Parse Baumarkt query for dimensions, materials, etc.
        const parsedBaumarktQuery = parseBaumarktQuery(query);
        
        const cached = searchCache.get(query);
        if (cached) {
          trackSearchEvent('cache_hit', { query });
          renderResults(cached.results, query, cached.variants, parsedBaumarktQuery);
          return;
        }
        
        showLoading();
        
        // Generiere Suchvarianten inklusive Baumarkt-Synonyme
        let searchVariants = generateSearchVariants(query);
        
        // Erweitere mit Baumarkt-Begriffen
        if (parsedBaumarktQuery.expandedTerms.length > 0) {
          parsedBaumarktQuery.expandedTerms.slice(0, 5).forEach(term => {
            if (!searchVariants.includes(term)) {
              searchVariants.push(term);
            }
          });
        }
        
        // Erweitere mit cleaner Query (ohne Maße/Füllwörter)
        if (parsedBaumarktQuery.cleanQuery && parsedBaumarktQuery.cleanQuery !== query.toLowerCase()) {
          if (!searchVariants.includes(parsedBaumarktQuery.cleanQuery)) {
            searchVariants.unshift(parsedBaumarktQuery.cleanQuery);
          }
        }
        
        // BUG 21 FIX: Limit to 5 variants max to avoid sequential API call waterfall
        searchVariants = searchVariants.slice(0, 5);
        
        const searchStartTime = performance.now();
        
        executeSearch(query, searchVariants, 0, searchStartTime, parsedBaumarktQuery);
      }
      
      function executeSearch(originalQuery, variants, variantIndex, searchStartTime = null, parsedBaumarktQuery = null) {
        if (variantIndex >= variants.length) {
          showEmpty(originalQuery);
          return;
        }
        
        const searchQuery = variants[variantIndex];
        const limit = SEARCH_CONFIG.limits.maxResults;
        const searchUrl = `${window.Shopify?.routes?.root || '/'}search/suggest.json?q=${encodeURIComponent(searchQuery)}&resources[type]=product,collection,article,page&resources[limit]=${limit}&resources[options][unavailable_products]=last`;
        
        fetch(searchUrl)
          .then(response => {
            if (!response.ok) throw new Error('Search failed');
            return response.json();
          })
          .then(data => {
            if (currentQuery !== originalQuery) return;
            
            const results = data?.resources?.results || {};
            // Lokalen Index als eigene Quelle dazumergen (SKU, "Vordach"->"Haustuervordach", Synonyme).
            try {
              const localMatches = getLocalProductMatches(originalQuery, parsedBaumarktQuery);
              if (localMatches.length) {
                results.products = mergeDedupeProducts(results.products || [], localMatches);
              }
            } catch (e) { /* native-Suche nie brechen */ }
            const hasProducts = results?.products?.length > 0;
            const hasOther = results?.collections?.length > 0 || results?.articles?.length > 0 || results?.pages?.length > 0;
            
            if (hasProducts || hasOther) {
              searchCache.set(originalQuery, {
                results: results,
                variants: variants
              });
              
              if (searchStartTime) {
                const searchDuration = performance.now() - searchStartTime;
                trackSearchEvent('search_complete', { 
                  query: originalQuery, 
                  duration: searchDuration,
                  resultCount: (results.products?.length || 0) + (results.collections?.length || 0)
                });
              }
              
              renderResults(results, originalQuery, variants, parsedBaumarktQuery);
            } else if (variantIndex < variants.length - 1) {
              executeSearch(originalQuery, variants, variantIndex + 1, searchStartTime, parsedBaumarktQuery);
            } else {
              showEmpty(originalQuery);
              trackSearchEvent('no_results', { query: originalQuery });
            }
          })
          .catch(error => {
            console.error('Search error:', error);
            // Native fehlgeschlagen (z.B. WAF liefert HTML) -> lokalen Index als Fallback nutzen.
            try {
              const localMatches = getLocalProductMatches(originalQuery, parsedBaumarktQuery);
              if (localMatches.length && currentQuery === originalQuery) {
                renderResults({ products: localMatches }, originalQuery, variants, parsedBaumarktQuery);
                return;
              }
            } catch (e) { /* ignore */ }
            if (variantIndex < variants.length - 1) {
              executeSearch(originalQuery, variants, variantIndex + 1, searchStartTime, parsedBaumarktQuery);
            } else {
              showEmpty(originalQuery);
            }
          });
      }
      
      function renderResults(results, query, searchVariants = [], parsedBaumarktQuery = null) {
        const products = results.products || [];
        const collections = results.collections || [];
        const articles = results.articles || [];
        const pages = results.pages || [];
        
        const hasResults = products.length > 0 || collections.length > 0 || articles.length > 0 || pages.length > 0;
        
        if (!hasResults) {
          showEmpty(query);
          return;
        }
        
        const totalCount = products.length + collections.length + articles.length + pages.length;
        updateTabCounts({
          all: totalCount,
          products: products.length,
          collections: collections.length,
          articles: articles.length,
          pages: pages.length
        });
        
        const counterEl = searchResults.querySelector('[data-search-counter]');
        if (counterEl) {
          // Show intent info if detected
          let counterHtml = `<strong>${totalCount}</strong> Ergebnis${totalCount !== 1 ? 'se' : ''} für "<strong>${escapeHtml(query)}</strong>"`;
          if (currentIntent) {
            if (currentIntent.wantsSale) counterHtml += ' <span style="color:var(--color-sale)">🏷️ Sale</span>';
            if (currentIntent.wantsNew) counterHtml += ' <span style="color:var(--color-accent)">✨ Neu</span>';
          }
          // Show parsed dimensions if found
          if (parsedBaumarktQuery?.dimensions) {
            const dims = parsedBaumarktQuery.dimensions;
            const dimParts = [];
            if (dims.length) dimParts.push(`${dims.length}mm`);
            if (dims.width) dimParts.push(`${dims.width}mm`);
            if (dims.thickness) dimParts.push(`${dims.thickness}mm`);
            if (dimParts.length > 0) {
              counterHtml += ` <span style="opacity:0.7">📐 ${dimParts.join(' × ')}</span>`;
            }
          }
          // Show detected properties
          if (parsedBaumarktQuery?.properties?.length > 0) {
            counterHtml += ` <span style="opacity:0.7">🔧 ${parsedBaumarktQuery.properties.slice(0, 2).join(', ')}</span>`;
          }
          counterEl.innerHTML = counterHtml;
        }
        
        // Score products with intent awareness AND Baumarkt deep matching
        const scoredProducts = products.map(product => {
          let score = calculateRelevanceScore(product, query, null, currentIntent);
          
          // Zusätzliches Baumarkt-Scoring wenn parsedQuery vorhanden
          if (parsedBaumarktQuery && productIndex.isInitialized) {
            // Versuche Produkt im Index zu finden
            const indexedProduct = productIndex.products.get(product.id);
            if (indexedProduct) {
              const baumarktMatch = deepMatchProduct(indexedProduct, parsedBaumarktQuery);
              score += baumarktMatch.score * 0.5; // Gewichtung des Baumarkt-Scorings
              product._baumarktMatches = baumarktMatch.matches;
            }
          }
          
          return {
            ...product,
            _relevanceScore: score
          };
        }).sort((a, b) => b._relevanceScore - a._relevanceScore);
        
        const productsList = searchResults.querySelector('[data-search-list="products"]');
        const productsSection = searchResults.querySelector('[data-search-section="products"]');
        if (productsList && productsSection) {
          if (scoredProducts.length > 0) {
            productsSection.style.display = '';
            
            const productItems = [];
            const normalizedQuery = normalizeForComparison(query);
            const maxVariantsShown = SEARCH_CONFIG.limits.maxVariantsShown;
            
            scoredProducts.forEach(product => {
              productItems.push(buildProductItem(product, query, null));
              
              if (product.variants && product.variants.length > 1) {
                const validVariants = product.variants.filter(v => 
                  v.title && v.title !== 'Default Title'
                );
                
                const matchingVariants = validVariants.filter(v => {
                  const normalizedVariant = normalizeForComparison(v.title);
                  const variantParts = v.title.toLowerCase().split(/[\s\/\-]+/);
                  
                  if (normalizedVariant.includes(normalizedQuery)) return true;
                  if (normalizedQuery.includes(normalizedVariant)) return true;
                  
                  return variantParts.some(part => {
                    const normalizedPart = normalizeForComparison(part);
                    return normalizedPart.includes(normalizedQuery) || 
                           normalizedQuery.includes(normalizedPart) ||
                           searchVariants.some(sv => normalizeForComparison(sv).includes(normalizedPart));
                  });
                });
                
                if (matchingVariants.length > 0) {
                  matchingVariants.slice(0, maxVariantsShown).forEach(variant => {
                    productItems.push(buildProductItem(product, query, variant));
                  });
                } else if (validVariants.length <= maxVariantsShown) {
                  validVariants.forEach(variant => {
                    productItems.push(buildProductItem(product, query, variant));
                  });
                } else {
                  validVariants.slice(0, Math.max(3, maxVariantsShown - 1)).forEach(variant => {
                    productItems.push(buildProductItem(product, query, variant));
                  });
                }
              }
            });
            
            const maxItems = SEARCH_CONFIG.limits.maxResults;
            productsList.innerHTML = productItems.slice(0, maxItems).join('');
          } else {
            productsSection.style.display = 'none';
          }
        }
        
        const collectionsList = searchResults.querySelector('[data-search-list="collections"]');
        const collectionsSection = searchResults.querySelector('[data-search-section="collections"]');
        if (collectionsList && collectionsSection) {
          if (collections.length > 0) {
            collectionsSection.style.display = '';
            collectionsList.innerHTML = collections.map(collection => `
              <li class="cdh-search-item cdh-search-item--collection">
                <a href="${collection.url}">
                  <div class="cdh-search-item-image cdh-collection-image">
                    ${collection.featured_image?.url ? `
                      <img src="${collection.featured_image.url.replace(/(\.[^.]+)$/, '_200x200_crop_center$1')}" alt="${escapeHtml(collection.featured_image.alt || collection.title)}" width="72" height="72" loading="lazy">
                    ` : `
                      <div class="cdh-collection-placeholder">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                          <rect x="3" y="3" width="7" height="7" rx="1"></rect>
                          <rect x="14" y="3" width="7" height="7" rx="1"></rect>
                          <rect x="3" y="14" width="7" height="7" rx="1"></rect>
                          <rect x="14" y="14" width="7" height="7" rx="1"></rect>
                        </svg>
                      </div>
                    `}
                    <span class="cdh-collection-badge">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
                      </svg>
                    </span>
                  </div>
                  <div class="cdh-search-item-info">
                    <span class="cdh-search-item-title">${highlightQuery(collection.title, query)}</span>
                    <span class="cdh-search-item-meta cdh-collection-meta">
                      ${collection.products_count ? `${collection.products_count} Produkte` : 'Kollektion'}
                    </span>
                    ${collection.description ? `
                      <span class="cdh-collection-desc">${escapeHtml(collection.description.replace(/<[^>]*>/g, '').substring(0, 50))}${collection.description.length > 50 ? '...' : ''}</span>
                    ` : ''}
                  </div>
                  <span class="cdh-collection-arrow">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <polyline points="9 18 15 12 9 6"></polyline>
                    </svg>
                  </span>
                </a>
              </li>
            `).join('');
          } else {
            collectionsSection.style.display = 'none';
          }
        }
        
        const articlesList = searchResults.querySelector('[data-search-list="articles"]');
        const articlesSection = searchResults.querySelector('[data-search-section="articles"]');
        if (articlesList && articlesSection) {
          if (articles.length > 0) {
            articlesSection.style.display = '';
            articlesList.innerHTML = articles.map(article => `
              <li class="cdh-search-item">
                <a href="${article.url}">
                  ${article.featured_image?.url ? `
                    <div class="cdh-search-item-image">
                      <img src="${article.featured_image.url.replace(/(\.[^.]+)$/, '_150x150$1')}" alt="${escapeHtml(article.featured_image.alt || article.title)}" width="72" height="72" loading="lazy">
                    </div>
                  ` : ''}
                  <div class="cdh-search-item-info">
                    <span class="cdh-search-item-title">${highlightQuery(article.title, query)}</span>
                    <span class="cdh-search-item-type">Blog</span>
                  </div>
                </a>
              </li>
            `).join('');
          } else {
            articlesSection.style.display = 'none';
          }
        }
        
        const pagesList = searchResults.querySelector('[data-search-list="pages"]');
        const pagesSection = searchResults.querySelector('[data-search-section="pages"]');
        if (pagesList && pagesSection) {
          if (pages.length > 0) {
            pagesSection.style.display = '';
            pagesList.innerHTML = pages.map(page => `
              <li class="cdh-search-item">
                <a href="${page.url}">
                  <div class="cdh-search-item-info">
                    <span class="cdh-search-item-title">${highlightQuery(page.title, query)}</span>
                    <span class="cdh-search-item-type">Seite</span>
                  </div>
                </a>
              </li>
            `).join('');
          } else {
            pagesSection.style.display = 'none';
          }
        }
        
        if (searchViewAll) {
          searchViewAll.href = `${window.Shopify?.routes?.root || '/'}search?q=${encodeURIComponent(query)}`;
          const viewAllCount = searchViewAll.querySelector('[data-view-all-count]');
          if (viewAllCount) {
            viewAllCount.textContent = totalCount;
          }
        }
        
        showResults();
      }
      
      function showLoading() {
        searchResults.setAttribute('aria-hidden', 'false');
        searchResults.classList.add('cdh-search-results--loading');
        searchResults.classList.remove('cdh-search-results--empty', 'cdh-search-results--has-results');
        resetEmptyState();
      }
      
      function showEmpty(query = '') {
        searchResults.setAttribute('aria-hidden', 'false');
        searchResults.classList.add('cdh-search-results--empty');
        searchResults.classList.remove('cdh-search-results--loading', 'cdh-search-results--has-results');
        
        const emptyContainer = searchResults.querySelector('[data-search-empty]');
        if (emptyContainer && query) {
          const suggestions = generateSuggestions(query);
          const hasSuggestions = suggestions.length > 0;
          
          emptyContainer.innerHTML = `
            <div class="cdh-search-empty-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                <circle cx="11" cy="11" r="8"></circle>
                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                <line x1="8" y1="8" x2="14" y2="14"></line>
                <line x1="14" y1="8" x2="8" y2="14"></line>
              </svg>
            </div>
            <div class="cdh-search-empty-content">
              <span class="cdh-search-empty-title">Keine Ergebnisse für "<strong>${escapeHtml(query)}</strong>"</span>
              <span class="cdh-search-empty-text">Wir konnten keine Produkte, Kollektionen, Blogs oder Seiten finden.</span>
              ${hasSuggestions ? `
                <div class="cdh-search-suggestions cdh-search-suggestions--prominent">
                  <span class="cdh-search-suggestions-title">🔍 Meinten Sie vielleicht:</span>
                  <ul class="cdh-search-suggestions-list">
                    ${suggestions.slice(0, 4).map(s => `
                      <li>
                        <button type="button" class="cdh-search-suggestion" data-suggestion="${escapeHtml(s)}">
                          ${escapeHtml(s)}
                        </button>
                      </li>
                    `).join('')}
                  </ul>
                </div>
              ` : `
                <div class="cdh-search-tips">
                  <span class="cdh-search-tips-title">💡 Tipps für die Suche:</span>
                  <ul class="cdh-search-tips-list">
                    <li>Überprüfen Sie die Rechtschreibung</li>
                    <li>Verwenden Sie weniger oder andere Suchbegriffe</li>
                    <li>Versuchen Sie allgemeinere Begriffe</li>
                  </ul>
                </div>
              `}
            </div>
          `;
          
          emptyContainer.querySelectorAll('[data-suggestion]').forEach(btn => {
            btn.addEventListener('click', () => {
              searchInput.value = btn.dataset.suggestion;
              searchbar.classList.add('cdh-searchbar--has-value');
              performSearch(btn.dataset.suggestion);
            });
          });
        }
      }
      
      function resetEmptyState() {
        const emptyContainer = searchResults.querySelector('[data-search-empty]');
        if (emptyContainer) {
          const noResultsText = config.noResultsText || 'Keine Ergebnisse gefunden';
          emptyContainer.innerHTML = `
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <circle cx="11" cy="11" r="8"></circle>
              <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
              <line x1="8" y1="8" x2="14" y2="14"></line>
              <line x1="14" y1="8" x2="8" y2="14"></line>
            </svg>
            <span>${noResultsText}</span>
          `;
        }
      }
      
      function generateSuggestions(query) {
        const suggestions = [];
        const q = query.toLowerCase().trim();
        const qPhonetic = koelnerPhonetik(q);
        const qStem = germanStem(q);
        
        // ========== 1. Shop Dictionary Matches ==========
        // Find similar words from actual shop products
        const shopMatches = shopDictionary.findSimilar(q);
        if (shopMatches.length > 0) {
          suggestions.push(...shopMatches.slice(0, 2));
        }
        
        // ========== 2. Common German Terms Dictionary ==========
        const commonTerms = {
          'tshirt': ['t-shirt', 'shirt', 'top'],
          't-shirt': ['tshirt', 'shirt', 'top'],
          'hose': ['jeans', 'pants', 'hosen'],
          'jacke': ['jacket', 'mantel', 'blazer'],
          'schuh': ['schuhe', 'sneaker', 'boots'],
          'tasche': ['bag', 'taschen', 'handtasche'],
          'kleid': ['dress', 'kleider', 'rock'],
          'pullover': ['sweater', 'pulli', 'hoodie'],
          'hemd': ['shirt', 'bluse', 'hemden'],
          'holz': ['holzplatte', 'holzbrett', 'massivholz'],
          'brett': ['bretter', 'holzbrett', 'platte'],
          'platte': ['platten', 'holzplatte', 'brett'],
          'tisch': ['tischplatte', 'schreibtisch', 'esstisch'],
          'stuhl': ['stühle', 'hocker', 'sessel'],
          'schrank': ['schränke', 'kommode', 'regal'],
          'lampe': ['leuchte', 'licht', 'lampen'],
          'sofa': ['couch', 'sofa', 'sessel'],
          'bett': ['betten', 'matratze', 'schlafzimmer']
        };
        
        Object.keys(commonTerms).forEach(key => {
          if (q.includes(key) || key.includes(q)) {
            suggestions.push(...commonTerms[key]);
          }
        });
        
        // ========== 3. Phonetic Suggestions ==========
        // Find words that sound similar (Meier → Meyer, Maier)
        const phoneticMatches = [];
        Object.keys(commonTerms).forEach(key => {
          if (koelnerPhonetik(key) === qPhonetic && key !== q) {
            phoneticMatches.push(key);
          }
        });
        
        // Check shop dictionary with phonetic matching
        shopDictionary.words.forEach(word => {
          if (word.length > 2 && koelnerPhonetik(word) === qPhonetic && word !== q) {
            phoneticMatches.push(word);
          }
        });
        
        if (phoneticMatches.length > 0) {
          suggestions.push(...phoneticMatches.slice(0, 2));
        }
        
        // ========== 4. Stem-based Suggestions ==========
        // Find words with same stem (holzplatten → holzplatte)
        shopDictionary.words.forEach(word => {
          if (word.length > 3 && germanStem(word) === qStem && word !== q) {
            if (!suggestions.includes(word)) {
              suggestions.push(word);
            }
          }
        });
        
        // ========== 5. N-Gram Similar Words ==========
        // Find words with high character sequence similarity
        const ngramMatches = [];
        shopDictionary.words.forEach(word => {
          if (word.length >= 4 && Math.abs(word.length - q.length) <= 3) {
            const similarity = ngramSimilarity(q, word);
            if (similarity > 0.5 && word !== q) {
              ngramMatches.push({ word, similarity });
            }
          }
        });
        
        // Sort by similarity and take top matches
        ngramMatches.sort((a, b) => b.similarity - a.similarity);
        suggestions.push(...ngramMatches.slice(0, 2).map(m => m.word));
        
        // ========== 6. Umlaut Variations ==========
        if (/[aou]/i.test(q)) {
          const umlauted = q.replace(/a/gi, 'ä').replace(/o/gi, 'ö').replace(/u/gi, 'ü');
          if (umlauted !== q && shopDictionary.words.has(umlauted)) {
            suggestions.push(umlauted);
          }
        }
        if (/[äöü]/i.test(q)) {
          const deumlauted = q.replace(/ä/gi, 'a').replace(/ö/gi, 'o').replace(/ü/gi, 'u');
          if (deumlauted !== q && shopDictionary.words.has(deumlauted)) {
            suggestions.push(deumlauted);
          }
        }
        
        // ========== 7. Partial Query Fallback ==========
        if (q.length > 6 && suggestions.length < 2) {
          // Try first half
          const firstHalf = q.substring(0, Math.ceil(q.length / 2));
          const firstHalfMatches = shopDictionary.findSimilar(firstHalf);
          if (firstHalfMatches.length > 0) {
            suggestions.push(firstHalfMatches[0]);
          }
        }
        
        // Dedupe and return max 4 suggestions
        const uniqueSuggestions = [...new Set(suggestions)]
          .filter(s => s !== q && s.length > 1)
          .slice(0, 4);
        
        return uniqueSuggestions;
      }
      
      function showResults() {
        searchResults.setAttribute('aria-hidden', 'false');
        searchResults.classList.add('cdh-search-results--has-results');
        searchResults.classList.remove('cdh-search-results--loading', 'cdh-search-results--empty');
        hideTrending();
        resetEmptyState();
        
        // Apply stagger animation to items
        const items = searchResults.querySelectorAll('.cdh-search-item');
        items.forEach((item, index) => {
          item.style.setProperty('--item-index', index);
        });
        
        // Image preview disabled - was causing unwanted popups
        // initImagePreview();
      }
      
      // ========== IMAGE PREVIEW ON HOVER ==========
      let previewTimeout = null;
      let previewEl = null;
      
      function initImagePreview() {
        // Create preview container if not exists
        if (!previewEl) {
          previewEl = document.createElement('div');
          previewEl.className = 'cdh-image-preview';
          previewEl.innerHTML = `
            <div class="cdh-image-preview-content">
              <button class="cdh-image-preview-close" type="button" aria-label="Schließen">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>
              <img class="cdh-image-preview-image" src="" alt="">
              <div class="cdh-image-preview-info">
                <div class="cdh-image-preview-title"></div>
                <div class="cdh-image-preview-price"></div>
              </div>
            </div>
          `;
          header.appendChild(previewEl);
          
          // Close handlers
          previewEl.addEventListener('click', (e) => {
            if (e.target === previewEl || e.target.closest('.cdh-image-preview-close')) {
              hidePreview();
            }
          });
          
          document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && previewEl.classList.contains('cdh-image-preview--visible')) {
              hidePreview();
            }
          });
        }
        
        // Add hover listeners to product items
        const productItems = searchResults.querySelectorAll('.cdh-search-item--product');
        productItems.forEach(item => {
          const imageUrl = item.dataset.previewImage;
          if (!imageUrl) return;
          
          item.addEventListener('mouseenter', () => {
            clearTimeout(previewTimeout);
            previewTimeout = setTimeout(() => {
              showPreview(
                imageUrl,
                item.dataset.previewTitle,
                item.dataset.previewPrice
              );
            }, 2000); // BUG 5 FIX: 2s delay to avoid accidental triggers
          });
          
          item.addEventListener('mouseleave', () => {
            clearTimeout(previewTimeout);
          });
        });
      }
      
      function showPreview(imageUrl, title, price) {
        if (!previewEl || !imageUrl) return;
        
        const img = previewEl.querySelector('.cdh-image-preview-image');
        const titleEl = previewEl.querySelector('.cdh-image-preview-title');
        const priceEl = previewEl.querySelector('.cdh-image-preview-price');
        
        img.src = imageUrl;
        img.alt = title || '';
        titleEl.textContent = title || '';
        priceEl.innerHTML = price || '';
        
        previewEl.classList.add('cdh-image-preview--visible');
      }
      
      function hidePreview() {
        if (previewEl) {
          previewEl.classList.remove('cdh-image-preview--visible');
        }
      }

      let currentSearchTab = 'all';
      
      function updateTabCounts(counts) {
        const tabContainer = searchResults.querySelector('[data-search-tabs]');
        if (!tabContainer) return;
        
        Object.entries(counts).forEach(([type, count]) => {
          const countEl = tabContainer.querySelector(`[data-tab-count="${type}"]`);
          if (countEl) {
            countEl.textContent = count;
          }
        });
      }
      
      function switchTab(tabType) {
        currentSearchTab = tabType;
        const tabContainer = searchResults.querySelector('[data-search-tabs]');
        if (!tabContainer) return;
        
        tabContainer.querySelectorAll('[data-search-tab]').forEach(btn => {
          btn.classList.toggle('cdh-search-tab--active', btn.dataset.searchTab === tabType);
        });
        
        const sections = ['products', 'collections', 'articles', 'pages'];
        sections.forEach(section => {
          const sectionEl = searchResults.querySelector(`[data-search-section="${section}"]`);
          if (sectionEl) {
            if (tabType === 'all') {
              const list = sectionEl.querySelector('[data-search-list]');
              sectionEl.style.display = list && list.children.length > 0 ? '' : 'none';
            } else {
              sectionEl.style.display = section === tabType ? '' : 'none';
            }
          }
        });
      }
      
      const tabContainer = searchResults?.querySelector('[data-search-tabs]');
      if (tabContainer) {
        tabContainer.addEventListener('click', (e) => {
          const btn = e.target.closest('[data-search-tab]');
          if (btn) {
            switchTab(btn.dataset.searchTab);
          }
        });
      }
      
      const tabsWrapper = searchResults?.querySelector('.cdh-search-tabs-wrapper');
      if (tabsWrapper) {
        const leftArrow = tabsWrapper.querySelector('[data-tabs-scroll="left"]');
        const rightArrow = tabsWrapper.querySelector('[data-tabs-scroll="right"]');
        const tabsScroller = tabsWrapper.querySelector('[data-search-tabs]');
        
        if (leftArrow && rightArrow && tabsScroller) {
          leftArrow.addEventListener('click', () => {
            tabsScroller.scrollBy({ left: -100, behavior: 'smooth' });
          });
          
          rightArrow.addEventListener('click', () => {
            tabsScroller.scrollBy({ left: 100, behavior: 'smooth' });
          });
        }
      }
      
      // ========== ANIMATED PLACEHOLDER ==========
      const ANIMATED_TERMS = (config.animatedTerms || []).filter(t => t && t.trim() !== '');
      const ANIMATION_ENABLED = config.animatePlaceholder !== false;
      const TYPE_SPEED = config.animationSpeed || 80; // Smoother - was 100
      const PAUSE_DURATION = config.animationPause || 2500; // Longer pause
      const DELETE_SPEED = 40; // Fast delete
      const CHAR_VARIANCE = 25; // Natural typing variance

      function initAnimatedPlaceholder(inputEl, placeholderEl) {
        if (!ANIMATION_ENABLED || !placeholderEl || ANIMATED_TERMS.length === 0) return;
        
        const textEl = placeholderEl.querySelector('[data-placeholder-text], [data-mobile-placeholder-text]');
        const cursorEl = placeholderEl.querySelector('.cdh-placeholder-cursor');
        if (!textEl) return;
        
        let currentTermIndex = 0;
        let currentCharIndex = 0;
        let isDeleting = false;
        let timeoutId = null;
        
        function updatePlaceholderVisibility() {
          if (inputEl && placeholderEl) {
            const hasValue = inputEl.value.length > 0;
            const isFocused = document.activeElement === inputEl;
            
            if (hasValue || isFocused) {
              placeholderEl.style.opacity = '0';
              placeholderEl.style.transform = 'translateY(-50%) translateX(-10px)';
              setTimeout(() => {
                if (inputEl.value.length > 0 || document.activeElement === inputEl) {
                  placeholderEl.style.visibility = 'hidden';
                }
              }, 200);
            } else {
              placeholderEl.style.visibility = 'visible';
              placeholderEl.style.opacity = '1';
              placeholderEl.style.transform = 'translateY(-50%) translateX(0)';
            }
            
            if (hasValue) {
              inputEl.classList.add('cdh-has-value');
            } else {
              inputEl.classList.remove('cdh-has-value');
            }
          }
        }
        
        function typeEffect() {
          const currentTerm = ANIMATED_TERMS[currentTermIndex];
          
          // Add subtle cursor blink effect during pause
          if (cursorEl) {
            cursorEl.style.animation = isDeleting ? 'none' : 'cdh-cursor-blink 0.8s ease-in-out infinite';
          }
          
          if (isDeleting) {
            currentCharIndex--;
            textEl.textContent = currentTerm.substring(0, currentCharIndex);
            
            if (currentCharIndex === 0) {
              isDeleting = false;
              currentTermIndex = (currentTermIndex + 1) % ANIMATED_TERMS.length;
              timeoutId = setTimeout(typeEffect, 400); // Pause before new word
            } else {
              // Fast delete with slight variance
              const deleteDelay = DELETE_SPEED + Math.random() * 15;
              timeoutId = setTimeout(typeEffect, deleteDelay);
            }
          } else {
            currentCharIndex++;
            textEl.textContent = currentTerm.substring(0, currentCharIndex);
            
            if (currentCharIndex === currentTerm.length) {
              isDeleting = true;
              timeoutId = setTimeout(typeEffect, PAUSE_DURATION);
            } else {
              // Natural typing with variance - slower for complex chars
              const char = currentTerm.charAt(currentCharIndex - 1);
              const isComplex = /[äöüßÄÖÜ]/.test(char);
              const baseSpeed = isComplex ? TYPE_SPEED * 1.3 : TYPE_SPEED;
              const variance = Math.random() * CHAR_VARIANCE - CHAR_VARIANCE / 2;
              timeoutId = setTimeout(typeEffect, baseSpeed + variance);
            }
          }
        }
        
        typeEffect();
        
        if (inputEl) {
          inputEl.addEventListener('input', updatePlaceholderVisibility);
          inputEl.addEventListener('focus', updatePlaceholderVisibility);
          inputEl.addEventListener('blur', () => {
            // BUG 3 FIX: Longer delay to prevent race condition with click on results
            setTimeout(updatePlaceholderVisibility, 300);
          });
        }
        
        return () => {
          if (timeoutId) clearTimeout(timeoutId);
        };
      }
      
      const desktopPlaceholder = searchbar?.querySelector('[data-animated-placeholder]');
      if (searchInput && desktopPlaceholder && ANIMATION_ENABLED) {
        initAnimatedPlaceholder(searchInput, desktopPlaceholder);
      }
      
      // ========== TRENDING/POPULAR SEARCHES ==========
      const TRENDING_SEARCHES = [
        'Stegplatten',
        'Wellplatten',
        'Überdachung',
        'Carport Zubehör',
        'Dachrinnen',
        'Verlegesysteme'
      ];
      
      function showTrending() {
        const trendingEl = searchResults?.querySelector('[data-search-trending]');
        const tagsEl = searchResults?.querySelector('[data-trending-tags]');
        if (!trendingEl || !tagsEl) return;
        
        tagsEl.innerHTML = TRENDING_SEARCHES.map(term => `
          <button type="button" class="cdh-search-trending-tag" data-trending-term="${escapeHtml(term)}">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="11" cy="11" r="8"></circle>
              <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
            </svg>
            ${escapeHtml(term)}
          </button>
        `).join('');
        
        tagsEl.querySelectorAll('[data-trending-term]').forEach(tag => {
          tag.addEventListener('click', () => {
            const term = tag.dataset.trendingTerm;
            if (searchInput) {
              searchInput.value = term;
              searchInput.dispatchEvent(new Event('input'));
            }
          });
        });
        
        trendingEl.style.display = '';
        searchResults.setAttribute('aria-hidden', 'false');
      }
      
      function hideTrending() {
        const trendingEl = searchResults?.querySelector('[data-search-trending]');
        if (trendingEl) {
          trendingEl.style.display = 'none';
        }
      }
      
      function hideResults() {
        searchResults.setAttribute('aria-hidden', 'true');
        searchResults.classList.remove('cdh-search-results--loading', 'cdh-search-results--empty', 'cdh-search-results--has-results');
        hideTrending();
        resetEmptyState();
      }
      
      function highlightQuery(text, query) {
        if (!query) return escapeHtml(text);
        const words = query.trim().split(/\s+/).filter(w => w.length >= 2);
        let result = escapeHtml(text);
        words.forEach(word => {
          const regex = new RegExp(`(${escapeRegExp(word)})`, 'gi');
          result = result.replace(regex, '<mark>$1</mark>');
        });
        return result;
      }
      
      function escapeHtml(text) {
        const div = document.createElement('div');
        div.textContent = text;
        return div.innerHTML;
      }
      
      function escapeRegExp(string) {
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      }
      
      function buildProductItem(product, query, specificVariant = null) {
        const isVariantSpecific = specificVariant !== null;
        
        let displayPrice = 0;
        let displayComparePrice = 0;
        let displayTitle = product.title;
        let productUrl = product.url;
        
        if (isVariantSpecific && specificVariant) {
          displayPrice = parseFloat(specificVariant.price) || 0;
          displayComparePrice = parseFloat(specificVariant.compare_at_price) || 0;
          displayTitle = `${product.title} - ${specificVariant.title}`;
          if (specificVariant.id) {
            productUrl = `${product.url}?variant=${specificVariant.id}`;
          }
        } else {
          displayPrice = parseFloat(product.price) || parseFloat(product.price_min) || 0;
          displayComparePrice = parseFloat(product.compare_at_price_min) || 0;
          if (displayComparePrice === 0 && product.compare_at_price) {
            displayComparePrice = parseFloat(product.compare_at_price) || 0;
          }
        }
        
        let badgesHtml = '';
        const badges = [];
        
        if (displayComparePrice > 0 && displayComparePrice > displayPrice) {
          const discount = Math.round((1 - displayPrice / displayComparePrice) * 100);
          if (discount > 0 && discount < 100) {
            badges.push(`<span class="cdh-search-badge cdh-search-badge--sale">-${discount}%</span>`);
          }
        }
        
        if (product.available === false) {
          badges.push(`<span class="cdh-search-badge cdh-search-badge--soldout">Ausverkauft</span>`);
        }
        
        if (badges.length > 0) {
          badgesHtml = `<div class="cdh-search-badges">${badges.join('')}</div>`;
        }
        
        let variantsHtml = '';
        const priceMin = parseFloat(product.price_min || product.price) || 0;
        const priceMax = parseFloat(product.price_max) || 0;
        const hasPriceRange = priceMin > 0 && priceMax > 0 && priceMin !== priceMax;
        
        if (!isVariantSpecific && hasPriceRange) {
          variantsHtml = `
            <div class="cdh-search-variants-info">
              <span class="cdh-search-variants-badge">Mehrere Varianten</span>
            </div>
          `;
        }
        
        if (!isVariantSpecific && product.variants && product.variants.length > 1) {
          const validVariants = product.variants.filter(v => 
            v.title && v.title !== 'Default Title'
          );
          
          if (validVariants.length > 0) {
            const variantCount = validVariants.length;
            const needsSlider = variantCount > 4;
            const sliderId = `variants-${product.id}-${Date.now()}`;
            
            variantsHtml = `
              <div class="cdh-search-variants-wrapper" data-variants-wrapper>
                <span class="cdh-search-variants-count">${variantCount} Varianten</span>
                ${needsSlider ? `
                  <button type="button" class="cdh-search-variants-nav cdh-search-variants-nav--prev cdh-search-variants-nav--hidden" data-variants-prev onclick="event.preventDefault(); event.stopPropagation(); this.parentElement.querySelector('[data-variants-list]').scrollBy({left: -100, behavior: 'smooth'});">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <polyline points="15 18 9 12 15 6"></polyline>
                    </svg>
                  </button>
                ` : ''}
                <div class="cdh-search-variants-slider">
                  <div class="cdh-search-variants" data-variants-list id="${sliderId}">
                    ${validVariants.map(v => `
                      <a href="${product.url}?variant=${v.id}" class="cdh-search-variant" onclick="event.stopPropagation();" title="${escapeHtml(v.title)}">
                        ${escapeHtml(v.title)}
                      </a>
                    `).join('')}
                  </div>
                </div>
                ${needsSlider ? `
                  <button type="button" class="cdh-search-variants-nav cdh-search-variants-nav--next" data-variants-next onclick="event.preventDefault(); event.stopPropagation(); this.parentElement.querySelector('[data-variants-list]').scrollBy({left: 100, behavior: 'smooth'});">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <polyline points="9 18 15 12 9 6"></polyline>
                    </svg>
                  </button>
                ` : ''}
              </div>
            `;
          }
        }
        
        let metaHtml = '';
        const metaItems = [];
        if (product.vendor && product.vendor !== 'Default Vendor' && product.vendor.toLowerCase() !== product.title.toLowerCase()) {
          metaItems.push(product.vendor);
        }
        if (product.product_type) {
          metaItems.push(product.product_type);
        }
        if (isVariantSpecific && specificVariant && specificVariant.sku) {
          metaItems.push(`SKU: ${specificVariant.sku}`);
        }
        if (metaItems.length > 0) {
          metaHtml = `<span class="cdh-search-item-meta">${escapeHtml(metaItems.join(' • '))}</span>`;
        }
        
        let descriptionHtml = '';
        if (product.body && !isVariantSpecific) {
          const plainText = product.body.replace(/<[^>]*>/g, '').trim();
          if (plainText.length > 0) {
            const shortDesc = plainText.length > 60 ? plainText.substring(0, 60) + '...' : plainText;
            descriptionHtml = `<span class="cdh-search-item-desc">${escapeHtml(shortDesc)}</span>`;
          }
        }
        
        let priceHtml = '';
        
        if (!isVariantSpecific && priceMin > 0 && priceMax > 0 && priceMin !== priceMax) {
          priceHtml = `<span class="cdh-price-range">${formatMoney(priceMin)} - ${formatMoney(priceMax)}</span>`;
        } else if (displayComparePrice > 0 && displayComparePrice > displayPrice) {
          priceHtml = `
            <span class="cdh-price-sale">${formatMoney(displayPrice)}</span>
            <span class="cdh-price-compare">${formatMoney(displayComparePrice)}</span>
          `;
        } else {
          priceHtml = formatMoney(displayPrice);
        }
        
        let stockHtml = '';
        if (product.available === false) {
          stockHtml = `<span class="cdh-search-stock cdh-search-stock--out">Nicht verfügbar</span>`;
        } else if (isVariantSpecific && specificVariant && specificVariant.available === false) {
          stockHtml = `<span class="cdh-search-stock cdh-search-stock--out">Nicht verfügbar</span>`;
        }
        
        // Get large image URL for preview
        const largeImageUrl = product.featured_image?.url ? 
          product.featured_image.url.replace(/(\.[^.]+)$/, '_600x600$1') : '';
        
        return `
          <li class="cdh-search-item cdh-search-item--product ${isVariantSpecific ? 'cdh-search-item--variant' : ''}"
              data-preview-image="${escapeHtml(largeImageUrl)}"
              data-preview-title="${escapeHtml(displayTitle)}"
              data-preview-price="${escapeHtml(priceHtml)}">
            <a href="${productUrl}">
              <div class="cdh-search-item-image ${!product.featured_image?.url ? 'cdh-search-item-image--placeholder' : ''}">
                ${product.featured_image?.url ? `
                  <img src="${product.featured_image.url.replace(/(\.[^.]+)$/, '_150x150$1')}" alt="${escapeHtml(product.featured_image.alt || product.title)}" width="72" height="72" loading="lazy">
                ` : `
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1">
                    <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                    <circle cx="8.5" cy="8.5" r="1.5"></circle>
                    <polyline points="21 15 16 10 5 21"></polyline>
                  </svg>
                `}
                ${badgesHtml}
              </div>
              <div class="cdh-search-item-info">
                ${metaHtml}
                <span class="cdh-search-item-title">${highlightQuery(displayTitle, query)}</span>
                ${descriptionHtml}
                ${variantsHtml}
                <div class="cdh-search-item-bottom">
                  <span class="cdh-search-item-price">${priceHtml}</span>
                  ${stockHtml}
                </div>
              </div>
            </a>
          </li>
        `;
      }
      
      function formatMoney(amount) {
        let price = typeof amount === 'string' ? parseFloat(amount) : amount;
        if (isNaN(price)) price = 0;
        
        const formatted = price.toFixed(2);
        const moneyFormat = config.moneyFormat || '{{amount}} €';
        const currency = config.currency || 'EUR';
        
        if (moneyFormat.includes('€')) {
          if (moneyFormat.indexOf('€') < moneyFormat.indexOf('amount')) {
            return '€' + formatted.replace('.', ',');
          } else {
            return formatted.replace('.', ',') + ' €';
          }
        } else if (moneyFormat.includes('$')) {
          if (moneyFormat.indexOf('$') < moneyFormat.indexOf('amount')) {
            return '$' + formatted;
          } else {
            return formatted + ' $';
          }
        } else if (moneyFormat.includes('CHF')) {
          return 'CHF ' + formatted.replace('.', ',');
        } else if (moneyFormat.includes('£')) {
          return '£' + formatted;
        } else {
          return formatted.replace('.', ',') + ' ' + currency;
        }
      }
      
      searchInput.addEventListener('input', (e) => {
        const query = e.target.value.trim();
        searchbar.classList.toggle('cdh-searchbar--has-value', query.length > 0);
        
        clearTimeout(searchTimeout);
        if (query.length >= 2) {
          searchTimeout = setTimeout(() => performSearch(query), 300);
        } else if (query.length === 0 && document.activeElement === searchInput) {
          // Show trending when user clears input but stays focused
          hideResults();
          showTrending();
        } else {
          hideResults();
        }
      });
      
      searchInput.addEventListener('focus', () => {
        const query = searchInput.value.trim();
        if (query.length >= 2) {
          performSearch(query);
        } else {
          // BUG 23 FIX: Show trending searches when input is empty on focus
          showTrending();
        }
      });
      
      if (searchClear) {
        searchClear.addEventListener('click', () => {
          searchInput.value = '';
          searchbar.classList.remove('cdh-searchbar--has-value');
          hideResults();
          searchInput.focus();
          // Show trending after clearing
          showTrending();
        });
      }
      
      // BUG 1 FIX: Use mousedown + check searchResults container
      document.addEventListener('mousedown', (e) => {
        if (!searchbar.contains(e.target) && !searchResults.contains(e.target)) {
          hideResults();
          searchbar.classList.remove('cdh-searchbar--mobile-open');
        }
      });
      
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          hideResults();
          searchbar.classList.remove('cdh-searchbar--mobile-open');
          searchInput.blur();
        }
      });
      
      // BUG 10 FIX: Close dropdown on scroll
      let searchScrollTimeout;
      window.addEventListener('scroll', () => {
        clearTimeout(searchScrollTimeout);
        searchScrollTimeout = setTimeout(() => {
          if (searchResults.getAttribute('aria-hidden') === 'false') {
            hideResults();
          }
        }, 200);
      }, { passive: true });
      
      if (mobileSearchToggle) {
        mobileSearchToggle.addEventListener('click', () => {
          searchbar.classList.add('cdh-searchbar--mobile-open');
          setTimeout(() => searchInput.focus(), 100);
        });
      }
      
      // ========================================
      // MOBILE SEARCH
      // ========================================
      const mobileSearchbarWrapper = header.querySelector('[data-mobile-searchbar-wrapper]');
      const mobileSearchInput = header.querySelector('[data-mobile-search-input]');
      const mobileSearchClear = header.querySelector('[data-mobile-search-clear]');
      const mobileSearchResults = header.querySelector('[data-mobile-search-results]');
      const mobileSearchViewAll = header.querySelector('[data-mobile-search-view-all]');
      
      const mobilePlaceholder = mobileSearchbarWrapper?.querySelector('[data-mobile-animated-placeholder]');
      if (mobileSearchInput && mobilePlaceholder) {
        initAnimatedPlaceholder(mobileSearchInput, mobilePlaceholder);
      }
      
      let currentMobileSearchTab = 'all';
      
      function updateMobileTabCounts(counts) {
        const tabContainer = mobileSearchResults?.querySelector('[data-mobile-search-tabs]');
        if (!tabContainer) return;
        
        Object.entries(counts).forEach(([type, count]) => {
          const countEl = tabContainer.querySelector(`[data-mobile-tab-count="${type}"]`);
          if (countEl) {
            countEl.textContent = count;
          }
        });
      }
      
      function switchMobileTab(tabType) {
        currentMobileSearchTab = tabType;
        const tabContainer = mobileSearchResults?.querySelector('[data-mobile-search-tabs]');
        if (!tabContainer) return;
        
        tabContainer.querySelectorAll('[data-mobile-search-tab]').forEach(btn => {
          btn.classList.toggle('cdh-search-tab--active', btn.dataset.mobileSearchTab === tabType);
        });
        
        const sections = ['products', 'collections', 'articles', 'pages'];
        sections.forEach(section => {
          const sectionEl = mobileSearchResults.querySelector(`[data-mobile-search-section="${section}"]`);
          if (sectionEl) {
            if (tabType === 'all') {
              const list = sectionEl.querySelector('[data-mobile-search-list]');
              sectionEl.style.display = list && list.children.length > 0 ? '' : 'none';
            } else {
              sectionEl.style.display = section === tabType ? '' : 'none';
            }
          }
        });
      }
      
      const mobileTabContainer = mobileSearchResults?.querySelector('[data-mobile-search-tabs]');
      if (mobileTabContainer) {
        mobileTabContainer.addEventListener('click', (e) => {
          const btn = e.target.closest('[data-mobile-search-tab]');
          if (btn) {
            switchMobileTab(btn.dataset.mobileSearchTab);
          }
        });
      }
      
      const mobileTabsWrapper = mobileSearchResults?.querySelector('.cdh-mobile-tabs-wrapper');
      if (mobileTabsWrapper) {
        const leftArrow = mobileTabsWrapper.querySelector('[data-mobile-tabs-scroll="left"]');
        const rightArrow = mobileTabsWrapper.querySelector('[data-mobile-tabs-scroll="right"]');
        const tabsScroller = mobileTabsWrapper.querySelector('[data-mobile-search-tabs]');
        
        if (leftArrow && rightArrow && tabsScroller) {
          leftArrow.addEventListener('click', () => {
            tabsScroller.scrollBy({ left: -100, behavior: 'smooth' });
          });
          
          rightArrow.addEventListener('click', () => {
            tabsScroller.scrollBy({ left: 100, behavior: 'smooth' });
          });
        }
      }
      
      if (mobileSearchbarWrapper && mobileSearchInput && mobileSearchResults) {
        let mobileSearchTimeout;
        let mobileCurrentQuery = '';
        
        // Keyboard-aware viewport height (for older users who type slowly)
        function updateVisualViewport() {
          if (window.visualViewport) {
            const vh = window.visualViewport.height;
            mobileSearchbarWrapper.style.setProperty('--cdh-visual-vh', vh + 'px');
          }
        }
        if (window.visualViewport) {
          window.visualViewport.addEventListener('resize', updateVisualViewport);
          updateVisualViewport();
        }
        
        function checkMobileSearchVisibility() {
          if (window.innerWidth <= 991) {
            mobileSearchbarWrapper.setAttribute('aria-hidden', 'false');
          } else {
            mobileSearchbarWrapper.setAttribute('aria-hidden', 'true');
            hideMobileResults();
          }
        }
        
        checkMobileSearchVisibility();
        window.addEventListener('resize', checkMobileSearchVisibility);
        
        function lockBodyScroll() {
          document.body.style.overflow = 'hidden';
          document.body.style.touchAction = 'none';
        }
        
        function unlockBodyScroll() {
          document.body.style.overflow = '';
          document.body.style.touchAction = '';
        }
        
        function showMobileLoading() {
          mobileSearchResults.setAttribute('aria-hidden', 'false');
          lockBodyScroll();
          const loadingEl = mobileSearchResults.querySelector('[data-mobile-search-loading]');
          const emptyEl = mobileSearchResults.querySelector('[data-mobile-search-empty]');
          const contentEl = mobileSearchResults.querySelector('[data-mobile-search-content]');
          if (loadingEl) loadingEl.style.display = 'flex';
          if (emptyEl) emptyEl.setAttribute('aria-hidden', 'true');
          if (contentEl) contentEl.setAttribute('aria-hidden', 'true');
        }
        
        function showMobileEmpty(query) {
          mobileSearchResults.setAttribute('aria-hidden', 'false');
          const loadingEl = mobileSearchResults.querySelector('[data-mobile-search-loading]');
          const emptyEl = mobileSearchResults.querySelector('[data-mobile-search-empty]');
          const contentEl = mobileSearchResults.querySelector('[data-mobile-search-content]');
          if (loadingEl) loadingEl.style.display = 'none';
          if (emptyEl) {
            emptyEl.setAttribute('aria-hidden', 'false');
            const suggestions = generateSuggestions(query);
            emptyEl.innerHTML = `
              <div class="cdh-search-empty-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                  <circle cx="11" cy="11" r="8"></circle>
                  <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                </svg>
              </div>
              <div class="cdh-search-empty-content">
                <span class="cdh-search-empty-title">Keine Ergebnisse für "<strong>${escapeHtml(query)}</strong>"</span>
                ${suggestions.length > 0 ? `
                  <div class="cdh-search-suggestions">
                    <span class="cdh-search-suggestions-title">Versuchen Sie:</span>
                    <ul class="cdh-search-suggestions-list">
                      ${suggestions.map(s => `<li><button type="button" class="cdh-search-suggestion" data-mobile-suggestion="${escapeHtml(s)}">${escapeHtml(s)}</button></li>`).join('')}
                    </ul>
                  </div>
                ` : ''}
              </div>
            `;
            emptyEl.querySelectorAll('[data-mobile-suggestion]').forEach(btn => {
              btn.addEventListener('click', () => {
                mobileSearchInput.value = btn.dataset.mobileSuggestion;
                performMobileSearch(btn.dataset.mobileSuggestion);
              });
            });
          }
          if (contentEl) contentEl.setAttribute('aria-hidden', 'true');
        }
        
        function showMobileContent() {
          mobileSearchResults.setAttribute('aria-hidden', 'false');
          const loadingEl = mobileSearchResults.querySelector('[data-mobile-search-loading]');
          const emptyEl = mobileSearchResults.querySelector('[data-mobile-search-empty]');
          const contentEl = mobileSearchResults.querySelector('[data-mobile-search-content]');
          if (loadingEl) loadingEl.style.display = 'none';
          if (emptyEl) emptyEl.setAttribute('aria-hidden', 'true');
          if (contentEl) contentEl.setAttribute('aria-hidden', 'false');
        }
        
        function hideMobileResults() {
          mobileSearchResults.setAttribute('aria-hidden', 'true');
          mobileCurrentQuery = '';
          unlockBodyScroll();
        }
        
        async function performMobileSearch(query) {
          const q = query.trim();
          
          if (q.length < 2) {
            hideMobileResults();
            return;
          }
          
          if (q === mobileCurrentQuery) return;
          mobileCurrentQuery = q;
          
          showMobileLoading();
          
          const variants = generateSearchVariants(q);
          const allProducts = new Map();
          const allCollections = new Map();
          const allArticles = new Map();
          const allPages = new Map();
          
          const fetchPromises = [...variants].slice(0, 5).map(async variant => {
            try {
              const response = await fetch(
                `${window.Shopify?.routes?.root || '/'}search/suggest.json?q=${encodeURIComponent(variant)}&resources[type]=product,collection,article,page&resources[limit]=10&resources[options][unavailable_products]=hide`
              );
              const data = await response.json();
              return { variant, data };
            } catch (e) {
              return { variant, data: null };
            }
          });
          
          const results = await Promise.all(fetchPromises);
          
          results.forEach(({ variant, data }) => {
            if (!data?.resources?.results) return;
            const r = data.resources.results;
            
            if (r.products) {
              r.products.forEach(p => {
                if (!allProducts.has(p.id)) {
                  allProducts.set(p.id, { ...p, matchedVariant: variant });
                }
              });
            }
            if (r.collections) {
              r.collections.forEach(c => {
                if (!allCollections.has(c.id)) allCollections.set(c.id, c);
              });
            }
            if (r.articles) {
              r.articles.forEach(a => {
                if (!allArticles.has(a.id)) allArticles.set(a.id, a);
              });
            }
            if (r.pages) {
              r.pages.forEach(p => {
                if (!allPages.has(p.id)) allPages.set(p.id, p);
              });
            }
          });
          
          const products = [...allProducts.values()].slice(0, 6);
          const collections = [...allCollections.values()].slice(0, 4);
          const articles = [...allArticles.values()].slice(0, 3);
          const pages = [...allPages.values()].slice(0, 3);
          
          const hasResults = products.length > 0 || collections.length > 0 || articles.length > 0 || pages.length > 0;
          
          if (!hasResults) {
            showMobileEmpty(q);
            return;
          }
          
          showMobileContent();
          
          const productsList = mobileSearchResults.querySelector('[data-mobile-search-list="products"]');
          const productsSection = mobileSearchResults.querySelector('[data-mobile-search-section="products"]');
          if (productsList && productsSection) {
            if (products.length > 0) {
              productsSection.style.display = '';
              productsList.innerHTML = products.map(product => buildProductItem(product, q, null)).join('');
            } else {
              productsSection.style.display = 'none';
            }
          }
          
          const collectionsList = mobileSearchResults.querySelector('[data-mobile-search-list="collections"]');
          const collectionsSection = mobileSearchResults.querySelector('[data-mobile-search-section="collections"]');
          if (collectionsList && collectionsSection) {
            if (collections.length > 0) {
              collectionsSection.style.display = '';
              collectionsList.innerHTML = collections.map(collection => `
                <li class="cdh-search-item cdh-search-item--collection">
                  <a href="${collection.url}">
                    <div class="cdh-search-item-image cdh-collection-image">
                      ${collection.featured_image?.url ? `
                        <img src="${collection.featured_image.url.replace(/(\.[^.]+)$/, '_200x200_crop_center$1')}" alt="${escapeHtml(collection.featured_image.alt || collection.title)}" width="50" height="50" loading="lazy">
                      ` : `
                        <div class="cdh-collection-placeholder">
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                            <rect x="3" y="3" width="7" height="7" rx="1"></rect>
                            <rect x="14" y="3" width="7" height="7" rx="1"></rect>
                            <rect x="3" y="14" width="7" height="7" rx="1"></rect>
                            <rect x="14" y="14" width="7" height="7" rx="1"></rect>
                          </svg>
                        </div>
                      `}
                      <span class="cdh-collection-badge">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                          <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
                        </svg>
                      </span>
                    </div>
                    <div class="cdh-search-item-info">
                      <span class="cdh-search-item-title">${highlightQuery(collection.title, q)}</span>
                      <span class="cdh-search-item-meta cdh-collection-meta">
                        ${collection.products_count ? `${collection.products_count} Produkte` : 'Kollektion'}
                      </span>
                    </div>
                    <span class="cdh-collection-arrow">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <polyline points="9 18 15 12 9 6"></polyline>
                      </svg>
                    </span>
                  </a>
                </li>
              `).join('');
            } else {
              collectionsSection.style.display = 'none';
            }
          }
          
          const articlesList = mobileSearchResults.querySelector('[data-mobile-search-list="articles"]');
          const articlesSection = mobileSearchResults.querySelector('[data-mobile-search-section="articles"]');
          if (articlesList && articlesSection) {
            if (articles.length > 0) {
              articlesSection.style.display = '';
              articlesList.innerHTML = articles.map(article => `
                <li class="cdh-search-item">
                  <a href="${article.url}">
                    ${article.featured_image?.url ? `
                      <div class="cdh-search-item-image">
                        <img src="${article.featured_image.url.replace(/(\.[^.]+)$/, '_100x100$1')}" alt="${escapeHtml(article.title)}" width="50" height="50" loading="lazy">
                      </div>
                    ` : ''}
                    <div class="cdh-search-item-info">
                      <span class="cdh-search-item-title">${highlightQuery(article.title, q)}</span>
                      <span class="cdh-search-item-type">Blog</span>
                    </div>
                  </a>
                </li>
              `).join('');
            } else {
              articlesSection.style.display = 'none';
            }
          }
          
          const pagesList = mobileSearchResults.querySelector('[data-mobile-search-list="pages"]');
          const pagesSection = mobileSearchResults.querySelector('[data-mobile-search-section="pages"]');
          if (pagesList && pagesSection) {
            if (pages.length > 0) {
              pagesSection.style.display = '';
              pagesList.innerHTML = pages.map(page => `
                <li class="cdh-search-item">
                  <a href="${page.url}">
                    <div class="cdh-search-item-info">
                      <span class="cdh-search-item-title">${highlightQuery(page.title, q)}</span>
                      <span class="cdh-search-item-type">Seite</span>
                    </div>
                  </a>
                </li>
              `).join('');
            } else {
              pagesSection.style.display = 'none';
            }
          }
          
          const totalCount = products.length + collections.length + articles.length + pages.length;
          updateMobileTabCounts({
            all: totalCount,
            products: products.length,
            collections: collections.length,
            articles: articles.length,
            pages: pages.length
          });
          
          if (mobileSearchViewAll) {
            mobileSearchViewAll.href = `${window.Shopify?.routes?.root || '/'}search?q=${encodeURIComponent(q)}`;
          }
        }
        
        const mobileSearchForm = mobileSearchbarWrapper.querySelector('.cdh-mobile-searchbar-form');
        
        mobileSearchInput.addEventListener('input', (e) => {
          clearTimeout(mobileSearchTimeout);
          const query = e.target.value.trim();
          
          // Toggle cdh-has-value on FORM (not input) so CSS sibling selector works for clear button
          if (mobileSearchForm) {
            mobileSearchForm.classList.toggle('cdh-has-value', query.length > 0);
          }
          
          if (query.length < 2) {
            hideMobileResults();
            return;
          }
          
          mobileSearchTimeout = setTimeout(() => {
            performMobileSearch(query);
          }, 300);
        });
        
        mobileSearchInput.addEventListener('focus', () => {
          if (mobileSearchInput.value.trim().length >= 2) {
            performMobileSearch(mobileSearchInput.value.trim());
          }
        });
        
        if (mobileSearchClear) {
          mobileSearchClear.addEventListener('click', (e) => {
            e.stopPropagation();
            mobileSearchInput.value = '';
            if (mobileSearchForm) {
              mobileSearchForm.classList.remove('cdh-has-value');
            }
            hideMobileResults();
            mobileSearchInput.focus();
          });
        }
        
        let isTouchingInput = false;
        
        mobileSearchInput.addEventListener('touchstart', () => {
          isTouchingInput = true;
        });
        
        mobileSearchInput.addEventListener('touchend', () => {
          setTimeout(() => { isTouchingInput = false; }, 300);
        });
        
        // BUG 26 FIX: Use mousedown consistent with desktop handler
        document.addEventListener('mousedown', (e) => {
          if (isTouchingInput) return;
          
          const searchWrapper = mobileSearchbarWrapper;
          const searchResultsEl = mobileSearchResults;
          
          if (searchWrapper && searchWrapper.contains(e.target)) return;
          if (searchResultsEl && searchResultsEl.contains(e.target)) return;
          
          hideMobileResults();
        });
        
        mobileSearchResults.addEventListener('click', (e) => {
          e.stopPropagation();
        });
        
        mobileSearchInput.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            const q = mobileSearchInput.value.trim();
            if (q.length > 0) {
              window.location.href = `${window.Shopify?.routes?.root || '/'}search?q=${encodeURIComponent(q)}`;
            }
          }
        });
      }
    }
  }
  
  // ========================================
  // INITIALIZATION
  // ========================================
  
  // Global initialization function
  window.initCstmHeaderDrawer = function(sectionId) {
    initCstmHeader(sectionId);
  };
  
  // Auto-initialize all headers on DOM ready
  function autoInit() {
    document.querySelectorAll('[data-cstm-header-drawer]').forEach(header => {
      initCstmHeader(header.id);
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', autoInit);
  } else {
    autoInit();
  }
  
  // Theme Editor support
  document.addEventListener('shopify:section:load', (e) => {
    const header = e.target.querySelector('[data-cstm-header-drawer]');
    if (header) {
      header.dataset.initialized = 'false';
      initCstmHeader(header.id);
    }
  });

  // ========================================
  // WISHLIST COUNTER IN HEADER
  // ========================================
  function updateWishlistCounter() {
    try {
      const list = JSON.parse(localStorage.getItem('cpc_wishlist') || '[]');
      const count = list.length;
      document.querySelectorAll('[data-wishlist-count]').forEach(el => {
        el.textContent = count;
        el.style.display = count > 0 ? '' : 'none';
      });
    } catch(e) {}
  }

  // Update on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateWishlistCounter);
  } else {
    updateWishlistCounter();
  }

  // Update when wishlist changes
  document.addEventListener('wishlist:updated', updateWishlistCounter);
  // Also listen for storage changes (other tabs)
  window.addEventListener('storage', (e) => {
    if (e.key === 'cpc_wishlist') updateWishlistCounter();
  });
})();
